
define('modules/application/header',[
    "app",

    // Libs
    "backbone",

    //Classes
    "./popup",
    "./dataProvider",
    "./wizard/classes/exportSolutionMaterialList"
  ],

  function(app, Backbone, Popup, DataProvider, ExportSolutionMaterialList) {

    var projectModel = Backbone.Model.extend({
      fetch: function() {},
      filterByName: function(name) {
        if (this.get("name").toLowerCase().indexOf(name.toLowerCase()) != -1)
          this.trigger("show:request");
        else
          this.trigger("hide:request");
      },

      filterBySystem: function(systemName) {
        if (this.get("content").indexOf(systemName) != -1)
          this.trigger("show:request");
        else
          this.trigger("hide:request");
      },

      filterByTicket: function(ticket) {
        if (this.get("ticket").indexOf(ticket) != -1)
          this.trigger("show:request");
        else
          this.trigger("hide:request");
      }

    });

    var projectCollection = Backbone.Collection.extend({
      model: projectModel,
      comparator: function(project) {
        return project.get("name");
      },

      getLine: function(accessoryLineCode) {
        if (accessoryLineCode === '') {
          return '';
        } else {
          var accessoryLines = BticinoS4B.Instances.Models.ApplicationModel.get('accessoryLines');
          if (accessoryLines) {
            for (var i = 0; i < accessoryLines.length; i++) {
              for (var j = 0; j < accessoryLines[i].colors.length; j++) {
                if (accessoryLines[i].colors[j].accessoryLineId == accessoryLineCode) {
                  //console.log(accessoryLines[i].colors[j]);
                  return accessoryLines[i].name;
                  //break;
                }
              }
            }
          }
        }
      },

      getColor: function(accessoryLineCode) {
        if (accessoryLineCode === '') {
          return '';
        } else {
          var accessoryLines = BticinoS4B.Instances.Models.ApplicationModel.get('accessoryLines');
          for (var i = 0; i < accessoryLines.length; i++) {
            for (var j = 0; j < accessoryLines[i].colors.length; j++) {
              if (accessoryLines[i].colors[j].accessoryLineId == accessoryLineCode) {
                //console.log(accessoryLines[i]);
                return accessoryLines[i].colors[j].name;
                //break;
              }
            }
          }
        }
      },

      getSystemsArray: function(stringContent) {
        var arrayResult = [];
        try {
          var objectContent = jQuery.parseJSON(stringContent);

          for (var sys in objectContent) {
            arrayResult.push(objectContent[sys].systemId);
          }
        } catch (err) {
          console.log(stringContent);
        }
        return arrayResult;
      },

      getKitsArray: function(stringContent) {
        var arrayResult = [];
        try {
          var objectContent = jQuery.parseJSON(stringContent);

          for (var sys in objectContent) {
            if (objectContent[sys].kitCode) {
              arrayResult.push(objectContent[sys].kitCode);
            }
          }
        } catch (err) {
          console.log(stringContent);
        }
        return arrayResult;
      },

      projectContainingSystemRequest: function(systems, filterSystem) {
        var isPresent = false;
        for (var i = 0; i < systems.length; i++) {
          if (systems[i] == filterSystem) {
            isPresent = true;
          }
        }
        return isPresent;
      },

      isInsertedSystem: function() {
        if (window.BticinoS4B.solution.thermoregulation.inserted || window.BticinoS4B.solution.audioVideo.inserted || window.BticinoS4B.solution.automation.inserted || window.BticinoS4B.solution.intrusionDetection.inserted || window.BticinoS4B.solution.automationSimple.inserted || window.BticinoS4B.solution.energyManagement.inserted)
          return true;
        else
          return false;
      },

      retrieveProjects: function(filterSystem, filterAccessoryLine) {
        var that = this,
          wiriningAccessoryLineCode,
          quoteType = BticinoS4B.Instances.Models.QuoteTypesMenuModel.get('quoteType'),
          successCallback = function(data) {
            that.reset();
            for (var i = 0; i < data.projects.length; i++) {
              if (data.projects[i].creationDate) {
                data.projects[i].creationDate = data.projects[i].creationDate.replace(/\//g, "");
                data.projects[i].creationDate = data.projects[i].creationDate.replace("Date(", "");
                data.projects[i].creationDate = data.projects[i].creationDate.replace(")", "");
                data.projects[i].creationDate = new Date(parseInt(data.projects[i].creationDate, 10));
              }

              if ((data.projects[i].lastEditDate) && (data.projects[i].lastEditDate !== null)) {
                data.projects[i].lastEditDate = data.projects[i].lastEditDate.replace(/\//g, "");
                data.projects[i].lastEditDate = data.projects[i].lastEditDate.replace("Date(", "");
                data.projects[i].lastEditDate = data.projects[i].lastEditDate.replace(")", "");
                data.projects[i].lastEditDate = new Date(parseInt(data.projects[i].lastEditDate, 10));
              }

              data.projects[i].line = that.getLine(data.projects[i].wiringAccessoryLineCode);
              data.projects[i].color = that.getColor(data.projects[i].wiringAccessoryLineCode);
              data.projects[i].systems = that.getSystemsArray(data.projects[i].content);
              data.projects[i].kits = that.getKitsArray(data.projects[i].content);
              var addCurrentProject = that.projectContainingSystemRequest(data.projects[i].systems, filterSystem);
              //console.log(data.projects[i].systems);

              if (data.projects[i].name.indexOf("<[") != -1)
                data.projects[i].name = data.projects[i].name.substring(0, data.projects[i].name.indexOf("<["));

              if (!filterSystem || addCurrentProject) {
                var project = new projectModel(data.projects[i]);
                that.add(project);
              }
            }
          };

        if ((quoteType == 'webapp') & (filterSystem === undefined)) {
          filterSystem = BticinoS4B.vars.system.id;
        }

        if (filterAccessoryLine) {
          wiriningAccessoryLineCode = BticinoS4B.Instances.Models.ApplicationModel.get("accessoryLineId");
        } else {
          wiriningAccessoryLineCode = undefined;
        }

        if (window.BticinoS4B.Instances.Models.loginModel.get('category') === 'CC') {
          window.BticinoS4B.Instances.Services.wizardServices.getGroupProjectList(wiriningAccessoryLineCode, successCallback);
        } else {
          window.BticinoS4B.Instances.Services.wizardServices.getProjectList(wiriningAccessoryLineCode, successCallback);
        }
      },

      loadRequestedEventHandler: function(modelToLoad) {
        window.BticinoS4B.projects.trigger("load:request", modelToLoad);
      },

      importRequestedEventHandler: function(modelToLoad) {
        window.BticinoS4B.projects.trigger("import:request", modelToLoad);
      },

      filterByName: function(name) {
        for (var i = 0; i < this.models.length; i++)
          this.models[i].filterByName(name);
      },

      filterBySystem: function(systemName) {
        for (var i = 0; i < this.models.length; i++)
          this.models[i].filterBySystem(systemName);
      },

      filterByTicket: function(ticket) {
        for (var i = 0; i < this.models.length; i++)
          this.models[i].filterByTicket(ticket);
      },
    });

    var projectView = Backbone.View.extend({
      tagName: "tr",
      template: "application/popups/project",
      events: {
        "mouseover": "setHoverColor",
        "mouseout": "unsetHoverColor",
        "click .trashButton": "deleteMe",
        "click .loadTable td": "loadMe",
        "click .importTable td": "importMe"
      },

      initialize: function() {
        this.model.bind("hide:request", this.hideMe, this);
        this.model.bind("show:request", this.showMe, this);
        window.BticinoS4B.projects.unbind("load:request");
        window.BticinoS4B.projects.bind("load:request", this.load, this);
        window.BticinoS4B.projects.unbind("import:request");
        window.BticinoS4B.projects.bind("import:request", this.import, this);
        // this.loader = new window.BticinoS4B.Instances.Views.LoaderView({model:{quote : "IDS_W4_9010", closeButton : false}});
      },

      hideMe: function() {
        this.$el.hide();
      },

      showMe: function() {
        this.$el.show();
      },

      serialize: function() {
        return {
          model: this.model,
          app: BticinoS4B.Instances.Models.ApplicationModel
        };
      },

      setHoverColor: function() {
        this.$el.css("background-color", "#e0e3e5");
        this.$el.find("td").css("color", "#000000");
      },

      unsetHoverColor: function() {
        this.$el.css("background-color", "#ffffff");
        this.$el.find("td").css("color", "#454545");
      },

      deleteMe: function(e) {
        if (confirm($.i18n._("IDS_W1_9088"))) {
          this.model.trigger("delete:request", this.model);
          this.$el.hide();
        }
        e.stopPropagation();
      },

      loadMe: function(e) {
        window.BticinoS4B.projects.trigger("load:request", this.model);
      },

      importMe: function(e) {
        window.BticinoS4B.projects.trigger("import:request", this.model);
      },

      setAccessoryLineColor: function(solutionSystem) {
        var line = _.filter(window.BticinoS4B.Instances.Models.ApplicationModel.get('accessoryLines'), function(iterableLine) {
          return iterableLine.id === solutionSystem.accessoryLine.line;
        })[0];
        var color = _.filter(line.colors, function(iterableColor) {
          return iterableColor.id === solutionSystem.accessoryLine.color;
        })[0];

        BticinoS4B.Instances.Models.ApplicationModel.set("choosenColor", color);
        BticinoS4B.Instances.Models.ApplicationModel.set("choosenLine", line);
        BticinoS4B.Instances.Models.ApplicationModel.set("accessoryLineId", color.accessoryLineId);
        return true;
      },
      showLoader: function() {
        this.loader.render();
        this.loader.prototype.prototype.show();
      },

      load: function(modelToLoad) {
        // this.showLoader();
        var that = this;
        var projectName = modelToLoad.get("name");
        var accessoryLineSelected = false;
        var solutionLoaded = {};
        if (BticinoS4B.Instances.Models.QuoteTypesMenuModel.QuoteType() == "s4b")
          window.BticinoS4B.Instances.Views.QuoteTypesMenuView.resetSystem();
        window.BticinoS4B.Instances.Models.ApplicationModel.InsertedProject = [];
        // this.showLoader();
        //window.BticinoS4B.eventAggregator.trigger("modelDeliver:request",this);
        if (modelToLoad) {
          BticinoS4B.Instances.Models.ApplicationModel.set("projectId", modelToLoad.get("id"));
          BticinoS4B.Instances.Models.ApplicationModel.set("projectName", modelToLoad.get("name"));
          BticinoS4B.Instances.Models.ApplicationModel.set("projectCreated", modelToLoad.get("creationDate"));
          BticinoS4B.Instances.Models.ApplicationModel.set("projectModified", modelToLoad.get("lastEditDate"));
          BticinoS4B.Instances.Models.ApplicationModel.set("projectTicket", modelToLoad.get("ticket"));
          BticinoS4B.Instances.Models.ApplicationModel.set("projectNote", modelToLoad.get("note"));
          BticinoS4B.Instances.Models.ApplicationModel.trigger("change:projectName");

          solutionLoaded = jQuery.parseJSON(modelToLoad.get("content"));

          if (solutionLoaded.audioVideo) {
            BticinoS4B.solution.audioVideo = solutionLoaded.audioVideo;
            BticinoS4B.modelToLoad.audioVideo = solutionLoaded.audioVideo;
            BticinoS4B.solution.audioVideo.inserted = true;

            if (!accessoryLineSelected) {
              accessoryLineSelected = this.setAccessoryLineColor(solutionLoaded.audioVideo);
            }
          }
          if (solutionLoaded.thermoregulation) {
            BticinoS4B.solution.thermoregulation = solutionLoaded.thermoregulation;
            BticinoS4B.modelToLoad.thermoregulation = solutionLoaded.thermoregulation;
            BticinoS4B.solution.thermoregulation.inserted = true;

            if (!accessoryLineSelected) {
              accessoryLineSelected = this.setAccessoryLineColor(solutionLoaded.thermoregulation);
            }
          }
          if (solutionLoaded.automation) {
            BticinoS4B.solution.automation = solutionLoaded.automation;
            BticinoS4B.modelToLoad.automation = solutionLoaded.automation;
            if (solutionLoaded.automation.kitCode) {
              BticinoS4B.Instances.Models.ApplicationModel.set("kitCode", solutionLoaded.automation.kitCode);
            } else {
              BticinoS4B.Instances.Models.ApplicationModel.set("kitCode", null);
            }
            BticinoS4B.solution.automation.inserted = true;

            if (!accessoryLineSelected) {
              accessoryLineSelected = this.setAccessoryLineColor(solutionLoaded.automation);
            }
          }
          if (solutionLoaded.intrusionDetection) {
            BticinoS4B.solution.intrusionDetection = solutionLoaded.intrusionDetection;
            BticinoS4B.modelToLoad.intrusionDetection = solutionLoaded.intrusionDetection;
            if (solutionLoaded.intrusionDetection.kitCode) {
              BticinoS4B.Instances.Models.ApplicationModel.set("kitCode", solutionLoaded.intrusionDetection.kitCode);
            } else {
              BticinoS4B.Instances.Models.ApplicationModel.set("kitCode", null);
            }
            BticinoS4B.solution.intrusionDetection.inserted = true;

            if (!accessoryLineSelected) {
              accessoryLineSelected = this.setAccessoryLineColor(solutionLoaded.intrusionDetection);
            }
          }

          if (solutionLoaded.automationSimple) {
            BticinoS4B.solution.automationSimple = solutionLoaded.automationSimple;
            BticinoS4B.modelToLoad.automationSimple = solutionLoaded.automationSimple;
            if (solutionLoaded.automationSimple.kitCode) {
              BticinoS4B.Instances.Models.ApplicationModel.set("kitCode", solutionLoaded.automationSimple.kitCode);
            } else {
              BticinoS4B.Instances.Models.ApplicationModel.set("kitCode", null);
            }
            BticinoS4B.solution.automationSimple.inserted = true;

            if (!accessoryLineSelected) {
              accessoryLineSelected = this.setAccessoryLineColor(solutionLoaded.automationSimple);
            }
          }

          if (solutionLoaded.energyManagement) {
            BticinoS4B.solution.energyManagement = solutionLoaded.energyManagement;
            BticinoS4B.modelToLoad.energyManagement = solutionLoaded.energyManagement;
            if (solutionLoaded.energyManagement.kitCode) {
              BticinoS4B.Instances.Models.ApplicationModel.set("kitCode", solutionLoaded.energyManagement.kitCode);
            } else {
              BticinoS4B.Instances.Models.ApplicationModel.set("kitCode", null);
            }
            BticinoS4B.solution.energyManagement.inserted = true;

            if (!accessoryLineSelected) {
              accessoryLineSelected = this.setAccessoryLineColor(solutionLoaded.energyManagement);
            }
          }

          //window.BticinoS4B.eventAggregator.trigger("load:Project", jQuery.parseJSON(modelToLoad.get("content")));
          Popup.View.prototype.hide.apply(this);
        }
        if (BticinoS4B.Instances.Models.QuoteTypesMenuModel && BticinoS4B.Instances.Models.QuoteTypesMenuModel.QuoteType() == "webapp") {
          if (BticinoS4B.solution.thermoregulation.inserted)
            window.BticinoS4B.eventAggregator.trigger("load:Project", BticinoS4B.modelToLoad.thermoregulation);
          else if (BticinoS4B.solution.automation.inserted)
            window.BticinoS4B.eventAggregator.trigger("load:Project", BticinoS4B.modelToLoad.automation);
          else if (BticinoS4B.solution.intrusionDetection.inserted)
            window.BticinoS4B.eventAggregator.trigger("load:Project", BticinoS4B.modelToLoad.intrusionDetection);
          else if (BticinoS4B.solution.audioVideo.inserted)
            window.BticinoS4B.eventAggregator.trigger("load:Project", BticinoS4B.modelToLoad.audioVideo);
          else if (BticinoS4B.solution.automationSimple.inserted)
            window.BticinoS4B.eventAggregator.trigger("load:Project", BticinoS4B.modelToLoad.automationSimple);
          else if (BticinoS4B.solution.energyManagement.inserted)
            window.BticinoS4B.eventAggregator.trigger("load:Project", BticinoS4B.modelToLoad.energyManagement);
        }
        window.BticinoS4B.eventAggregator.trigger("zoneValidityUpdate:request");
        //trick to refresh view
        window.BticinoS4B.eventAggregator.trigger("language:changed");
        // this.hideLoader();
      },

      import: function(modelToLoad) {
        var that = this;
        var solutionLoaded = {};
        var systemImported = false;
        window.BticinoS4B.Instances.Models.ApplicationModel.InsertedProject = [];
        // this.showLoader();
        //window.BticinoS4B.eventAggregator.trigger("modelDeliver:request",this);
        if (modelToLoad) {

          solutionLoaded = jQuery.parseJSON(modelToLoad.get("content"));

          if ((solutionLoaded.thermoregulation) && (window.BticinoS4B.vars.systemToImport == '#2')) {
            BticinoS4B.solution.thermoregulation = solutionLoaded.thermoregulation;
            BticinoS4B.modelToLoad.thermoregulation = solutionLoaded.thermoregulation;
            BticinoS4B.solution.thermoregulation.inserted = true;
            systemImported = true;
          }
          if ((solutionLoaded.intrusionDetection) && (window.BticinoS4B.vars.systemToImport == '#4')) {
            BticinoS4B.solution.intrusionDetection = solutionLoaded.intrusionDetection;
            BticinoS4B.modelToLoad.intrusionDetection = solutionLoaded.intrusionDetection;
            if (solutionLoaded.intrusionDetection.kitCode) {
              BticinoS4B.Instances.Models.ApplicationModel.set("kitCode", solutionLoaded.intrusionDetection.kitCode);
            } else {
              BticinoS4B.Instances.Models.ApplicationModel.set("kitCode", null);
            }
            BticinoS4B.solution.intrusionDetection.inserted = true;
            systemImported = true;
          }
          if ((solutionLoaded.audioVideo) && (window.BticinoS4B.vars.systemToImport == '#5+6')) {
            BticinoS4B.solution.audioVideo = solutionLoaded.audioVideo;
            BticinoS4B.modelToLoad.audioVideo = solutionLoaded.audioVideo;
            BticinoS4B.solution.audioVideo.inserted = true;
            systemImported = true;
          }
          if ((solutionLoaded.automation) && (window.BticinoS4B.vars.systemToImport == '#13+20')) {
            BticinoS4B.solution.automation = solutionLoaded.automation;
            BticinoS4B.modelToLoad.automation = solutionLoaded.automation;
            if (solutionLoaded.automation.kitCode) {
              BticinoS4B.Instances.Models.ApplicationModel.set("kitCode", solutionLoaded.automation.kitCode);
            } else {
              BticinoS4B.Instances.Models.ApplicationModel.set("kitCode", null);
            }
            BticinoS4B.solution.automation.inserted = true;
            systemImported = true;
          }
          if ((solutionLoaded.automationSimple) && (window.BticinoS4B.vars.systemToImport == '#13')) {
            BticinoS4B.solution.automationSimple = solutionLoaded.automationSimple;
            BticinoS4B.modelToLoad.automationSimple = solutionLoaded.automationSimple;
            if (solutionLoaded.automationSimple.kitCode) {
              BticinoS4B.Instances.Models.ApplicationModel.set("kitCode", solutionLoaded.automationSimple.kitCode);
            } else {
              BticinoS4B.Instances.Models.ApplicationModel.set("kitCode", null);
            }
            BticinoS4B.solution.automationSimple.inserted = true;
            systemImported = true;
          }
          if ((solutionLoaded.energyManagement) && (window.BticinoS4B.vars.systemToImport == '#21')) {
            BticinoS4B.solution.energyManagement = solutionLoaded.energyManagement;
            BticinoS4B.modelToLoad.energyManagement = solutionLoaded.energyManagement;
            if (solutionLoaded.energyManagement.kitCode) {
              BticinoS4B.Instances.Models.ApplicationModel.set("kitCode", solutionLoaded.energyManagement.kitCode);
            } else {
              BticinoS4B.Instances.Models.ApplicationModel.set("kitCode", null);
            }
            BticinoS4B.solution.energyManagement.inserted = true;
            systemImported = true;
          }

          Popup.View.prototype.hide.apply(this);
        }
        if (!systemImported) {
          alert('Non è stato importato nessun sistema. (La soluzione non contiene il sistema selezionato.)');
        } else {
          window.BticinoS4B.eventAggregator.trigger("zoneValidityUpdate:request");
          //trick to refresh view
          window.BticinoS4B.eventAggregator.trigger("language:changed");
          window.BticinoS4B.vars.systemToImport = '';
          // this.hideLoader();        
        }
      }
    });

    // Create a new module
    var Header = app.module();

    // Header Model
    // ----------
    Header.Model = Backbone.Model.extend();

    Header.SaveView = Popup.View.extend({
      className: "popup save",
      template: "application/popups/save",
      events: {
        "click .tableContainer tr": "loadName"
      },

      initialize: function() {
        window.BticinoS4B.projects = new projectCollection([]);

        window.BticinoS4B.projects.unbind("save:request", this.save);
        window.BticinoS4B.projects.bind("save:request", this.save, this);

        window.BticinoS4B.projects.unbind("delete:request", this.deleteProject);
        window.BticinoS4B.projects.bind("delete:request", this.deleteProject, this);

        window.BticinoS4B.eventAggregator.unbind("update:requested", this.update);
        window.BticinoS4B.eventAggregator.bind("update:requested", this.update, this);

        //window.BticinoS4B.projects = projects;
        /*if (app.loginModel.isAuthenticated())
          this.retrieveData();
          */
      },

      loadName: function(e) {
        $(this.$el.find("input[name='projectName']")[0]).val($(e.currentTarget).find(".name").text());
      },

      showLoader: function(e) {
        $(this.$el.find("table")).hide();
        $(this.$el.find(".save")).hide();
        $(this.$el.find(".footer")).hide();
        $(this.$el.find(".loader")).show();
      },

      show: function(force, callback, scope) {
        if ((BticinoS4B.Instances.Models.ApplicationModel.get("projectId")) && (!force)) {
          this.update(true, BticinoS4B.Instances.Models.ApplicationModel.get("projectId"));
          if (callback)
            callback.call(scope);
        } else {
          this.render();
          this.retrieveData();
          this.render();
          if (callback)
            Popup.View.prototype.show.apply(this, [null, callback, scope]);
          else
            Popup.View.prototype.show.apply(this);
        }
      },

      retrieveData: function() {
        var that = this;
        window.BticinoS4B.projects.retrieveProjects();
        _.each(window.BticinoS4B.projects.models, function(project) {
          that.insertView(".projects", new projectView({
            model: project
          }));
        });
      },

      deleteProject: function(modelToDelete) {
        var that = this;
        var ProjectToDeleteID = modelToDelete.get("id");
        var successCallback = function() {
          console.log('Project ' + ProjectToDeleteID + ' deleted');
        };
        window.BticinoS4B.Instances.Services.wizardServices.deleteProject(ProjectToDeleteID, successCallback);
      },

      retrieveAllModelsData: function() {
        var modelThermo = {},
          modelAudioVideo = {},
          modelIntrusionDetection = {},
          modelAutomation = {},
          modelAutomationSimple = {},
          modelEnergyManagement = {};

        if (BticinoS4B.solution.thermoregulation.inserted)
          modelThermo = BticinoS4B.Classes.calculationClassThermoregulation.retrieveModels();

        if (BticinoS4B.solution.audioVideo.inserted)
          modelAudioVideo = BticinoS4B.Classes.calculationClassAudioVideo.retrieveModels();

        if (BticinoS4B.solution.intrusionDetection.inserted)
          modelIntrusionDetection = BticinoS4B.Classes.calculationClassIntrusionDetection.retrieveModels();

        if (BticinoS4B.solution.automation.inserted)
          modelAutomation = BticinoS4B.Classes.calculationClassAutomation.retrieveModels();

        if (BticinoS4B.solution.automationSimple.inserted)
          modelAutomationSimple = BticinoS4B.Classes.calculationClassAutomationSimple.retrieveModels();

        if (BticinoS4B.solution.energyManagement.inserted)
          modelEnergyManagement = BticinoS4B.Classes.calculationClassEnergyManagement.retrieveModels();

        var solution = {};

        if (BticinoS4B.solution.thermoregulation.inserted && modelThermo.inserted) {
          solution.thermoregulation = modelThermo;
        }
        if (BticinoS4B.solution.audioVideo.inserted && modelAudioVideo.inserted) {
          solution.audioVideo = modelAudioVideo;
        }
        if (BticinoS4B.solution.intrusionDetection.inserted && modelIntrusionDetection.inserted) {
          solution.intrusionDetection = modelIntrusionDetection;
        }
        if (BticinoS4B.solution.automation.inserted && modelAutomation.inserted) {
          solution.automation = modelAutomation;
        }
        if (BticinoS4B.solution.automationSimple.inserted && modelAutomationSimple.inserted) {
          solution.automationSimple = modelAutomationSimple;
        }
        if (BticinoS4B.solution.energyManagement.inserted && modelEnergyManagement.inserted) {
          solution.energyManagement = modelEnergyManagement;
        }
        return solution;
      },

      update: function(_notSilent, projectID_in) {
        var that = this;
        var name = BticinoS4B.Instances.Models.ApplicationModel.get("projectName");
        var projectId = projectID_in;
        var wiringAccessoryLineCode = BticinoS4B.Instances.Models.ApplicationModel.get("wiringAccessoryLineId");
        var modelToSave = this.retrieveAllModelsData();
        var silent = true;
        var ticket = BticinoS4B.Instances.Models.ApplicationModel.get("projectTicket"),
            note   = BticinoS4B.Instances.Models.ApplicationModel.get("projectNote");

        var successUpdateCB = function(data) {
          if (data.result) {
            BticinoS4B.Instances.Models.ApplicationModel.set("alreadySaved", true);
            BticinoS4B.Instances.Models.ApplicationModel.set("projectName", BticinoS4B.Instances.Models.ApplicationModel.get("projectName"));
            BticinoS4B.Instances.Models.ApplicationModel.set("projectModified", new Date());
            BticinoS4B.Instances.Models.ApplicationModel.set("projectTicket", ticket);
            BticinoS4B.Instances.Models.ApplicationModel.trigger("change:projectName");
            Popup.View.prototype.hide.apply(that);
            if (!silent)
              alert($.i18n._("IDS_W1_9085"));
          }
        };

        if (_notSilent)
          silent = !_notSilent;

        window.BticinoS4B.Instances.Services.wizardServices.updateProject(name, projectId, modelToSave, wiringAccessoryLineCode, ticket, note, successUpdateCB);
        window.BticinoS4B.eventAggregator.trigger("language:changed", BticinoS4B.Instances.Models.ApplicationModel.get("currentLanguage"));
      },

      closeButtonClickedEventHandler: function() {
        this.save();
      },

      save: function() {
        var that = this;
        var projectName = this.$el.find("input[name='projectName']").val(); // + "<[" + BticinoS4B.Instances.Models.ApplicationModel.get("systemId") + "]>";
        var nameAlreadyPresent = false;
        var ticket = this.$el.find("input[name='projectTicket']")  ? this.$el.find("input[name='projectTicket']").val()  : '',
            note   = this.$el.find("textarea[name='projectNote']") ? this.$el.find("textarea[name='projectNote']").val() : '';

        /*Checking if the project name is already present*/
        for (var i = 0; i < window.BticinoS4B.projects.models.length; i++) {
          if (window.BticinoS4B.projects.models[i].get("name") == projectName) {
            nameAlreadyPresent = window.BticinoS4B.projects.models[i].get("id");
            break;
          }
        }

        if (nameAlreadyPresent === false) {
          var modelToSave = {};

          if (projectName !== "") {
            this.showLoader();

            modelToSave = this.retrieveAllModelsData();

            wiriningAccessoryLineCode = BticinoS4B.Instances.Models.ApplicationModel.get("accessoryLineId");
            var successSaveProjectCB = function(data) {
              if (data.result) {
                BticinoS4B.Instances.Models.ApplicationModel.set("projectModified", new Date());
                //BticinoS4B.Instances.Models.ApplicationModel.set("projectName", projectName.substring(0, projectName.indexOf("<[")));
                BticinoS4B.Instances.Models.ApplicationModel.set("projectName", projectName);
                BticinoS4B.Instances.Models.ApplicationModel.trigger("change:projectName");
                BticinoS4B.Instances.Models.ApplicationModel.set("projectId", data.projectId);
                BticinoS4B.Instances.Models.ApplicationModel.set("projectTicket", ticket);
                BticinoS4B.Instances.Models.ApplicationModel.set("alreadySaved", true);
                Popup.View.prototype.hide.apply(that);
                alert($.i18n._("IDS_W1_9085"));
              }
            };
            window.BticinoS4B.Instances.Services.wizardServices.saveProject(projectName, modelToSave, wiriningAccessoryLineCode, ticket, note, successSaveProjectCB);
          }
        } else if (confirm("Sovrascrivere?")) {
          BticinoS4B.Instances.Models.ApplicationModel.set("projectId", nameAlreadyPresent);
          BticinoS4B.Instances.Models.ApplicationModel.set("projectModified", new Date());
          BticinoS4B.Instances.Models.ApplicationModel.set("projectName", projectName.substring(0, projectName.indexOf("<[")));
          BticinoS4B.Instances.Models.ApplicationModel.set("projectTicket", ticket);
          this.update(true, nameAlreadyPresent);
        }
        window.BticinoS4B.eventAggregator.trigger("language:changed", BticinoS4B.Instances.Models.ApplicationModel.get("currentLanguage"));
      }
    });

    Header.SaveSingleView = Popup.View.extend({
      className: "popup save",
      template: "application/popups/save",
      events: {
        "click .tableContainer tr": "loadName"
      },

      initialize: function() {
        window.BticinoS4B.projects = new projectCollection([]);

        window.BticinoS4B.projects.unbind("save:request", this.save);
        window.BticinoS4B.projects.bind("save:request", this.save, this);
      },

      loadName: function(e) {
        $(this.$el.find("input[name='projectName']")[0]).val($(e.currentTarget).find(".name").text());
      },

      showLoader: function(e) {
        $(this.$el.find("table")).hide();
        $(this.$el.find(".save")).hide();
        $(this.$el.find(".footer")).hide();
        $(this.$el.find(".loader")).show();
      },

      show: function(force, callback, scope) {
        this.render();
        this.retrieveData();
        this.render();
        if (callback)
          Popup.View.prototype.show.apply(this, [null, callback, scope]);
        else
          Popup.View.prototype.show.apply(this);
      },

      retrieveData: function() {
        var that = this;
        window.BticinoS4B.projects.retrieveProjects();
        _.each(window.BticinoS4B.projects.models, function(project) {
          that.insertView(".projects", new projectView({
            model: project
          }));
        });
      },

      retrieveSingleModelsData: function() {
        var modelThermo = {},
          modelAudioVideo = {},
          modelIntrusionDetection = {},
          modelAutomation = {},
          modelAutomationSimple = {},
          modelEnergyManagement = {},
          solution = {},
          systemID = window.BticinoS4B.Instances.Models.ApplicationModel.get("systemId");

        switch (systemID) {
          case "#2":
            if (BticinoS4B.solution.thermoregulation.inserted) {
              modelThermo = BticinoS4B.Classes.calculationClassThermoregulation.retrieveModels();
              solution.thermoregulation = modelThermo;
            }
            break;

          case "#4":
            if (BticinoS4B.solution.intrusionDetection.inserted) {
              modelIntrusionDetection = BticinoS4B.Classes.calculationClassIntrusionDetection.retrieveModels();
              solution.intrusionDetection = modelIntrusionDetection;
            }
            break;

          case "#5+6":
            if (BticinoS4B.solution.audioVideo.inserted) {
              modelAudioVideo = BticinoS4B.Classes.calculationClassAudioVideo.retrieveModels();
              solution.audioVideo = modelAudioVideo;
            }
            break;

          case "#13+20":
            if (BticinoS4B.solution.automation.inserted) {
              modelAutomation = BticinoS4B.Classes.calculationClassAutomation.retrieveModels();
              solution.automation = modelAutomation;
            }
            break;

          case "#13":
            if (BticinoS4B.solution.automationSimple.inserted) {
              modelAutomationSimple = BticinoS4B.Classes.calculationClassAutomationSimple.retrieveModels();
              solution.automationSimple = modelAutomationSimple;
            }
            break;

          case "#21":
            if (BticinoS4B.solution.energyManagement.inserted) {
              modelEnergyManagement = BticinoS4B.Classes.calculationClassEnergyManagement.retrieveModels();
              solution.energyManagement = modelEnergyManagement;
            }
            break;
        }
        return solution;
      },

      closeButtonClickedEventHandler: function() {
        this.save();
      },

      save: function() {
        var that = this;

        var projectName = this.$el.find("input[name='projectName']").val(); // + "<[" + BticinoS4B.Instances.Models.ApplicationModel.get("systemId") + "]>";
        var nameAlreadyPresent = false;
        var ticket = '', note = '';

        /*Checking if the project name is already present*/
        for (var i = 0; i < window.BticinoS4B.projects.models.length; i++) {
          if (window.BticinoS4B.projects.models[i].get("name") == projectName) {
            nameAlreadyPresent = window.BticinoS4B.projects.models[i].get("id");
            break;
          }
        }

        if (nameAlreadyPresent === false) {
          var modelToSave = {};

          if (projectName !== "") {
            this.showLoader();

            modelToSave = this.retrieveSingleModelsData();

            wiriningAccessoryLineCode = BticinoS4B.Instances.Models.ApplicationModel.get("accessoryLineId");
            var successSaveProjectCB = function(data) {
              if (data.result) {
                BticinoS4B.Instances.Models.ApplicationModel.set("projectModified", new Date());
                //BticinoS4B.Instances.Models.ApplicationModel.set("projectName", projectName.substring(0, projectName.indexOf("<[")));
                BticinoS4B.Instances.Models.ApplicationModel.set("projectName", projectName);
                BticinoS4B.Instances.Models.ApplicationModel.trigger("change:projectName");
                BticinoS4B.Instances.Models.ApplicationModel.set("projectId", data.projectId);
                BticinoS4B.Instances.Models.ApplicationModel.set("alreadySaved", true);
                Popup.View.prototype.hide.apply(that);
                alert($.i18n._("IDS_W1_9085"));
              }
            };
            window.BticinoS4B.Instances.Services.wizardServices.saveProject(projectName, modelToSave, wiriningAccessoryLineCode, ticket, note, successSaveProjectCB);
          }
        } else if (confirm("Sovrascrivere?")) {
          BticinoS4B.Instances.Models.ApplicationModel.set("projectId", nameAlreadyPresent);
          BticinoS4B.Instances.Models.ApplicationModel.set("projectModified", new Date());
          BticinoS4B.Instances.Models.ApplicationModel.set("projectName", projectName.substring(0, projectName.indexOf("<[")));
          this.update(true, nameAlreadyPresent);
        }
      }
    });

    Header.LoadView = Popup.View.extend({
      className: "popup load",
      template: "application/popups/load",
      events: {
        "keyup input[name='projectName']": "filterList"
      },

      initialize: function() {
        window.BticinoS4B.projects = new projectCollection([]);
        // window.BticinoS4B.projects.bind("load:request", this.load, this);
        window.BticinoS4B.projects.bind("delete:request", this.deleteProject, this);
        //this.model.projects = projects;
        //if (app.loginModel.isAuthenticated())
        //  this.retrieveData();
      },

      retrieveData: function() {
        var that = this;
        window.BticinoS4B.projects.retrieveProjects();
        _.each(window.BticinoS4B.projects.models, function(project) {
          that.insertView(".projects", new projectView({
            model: project
          }));
        });
      },

      showLoader: function(e) {
        $(this.$el.find("table")).hide();
        $(this.$el.find(".save")).hide();
        $(this.$el.find(".loader")).show();
      },

      hideLoader: function(e) {
        $(this.$el.find(".loader")).hide();
        $(this.$el.find("table")).show();
        $(this.$el.find(".save")).show();
      },

      filterList: function(e) {
        window.BticinoS4B.projects.filterByName(e.currentTarget.value);
      },

      show: function() {
        this.render();
        this.retrieveData();
        this.render();
        Popup.View.prototype.show.apply(this);
      },

      // load: function(modelToLoad) {
      //   var that = this;
      //   var projectName = modelToLoad.get("name");
      //   this.showLoader();
      //   //window.BticinoS4B.eventAggregator.trigger("modelDeliver:request",this);
      //   if (modelToLoad) {
      //     BticinoS4B.Instances.Models.ApplicationModel.set("projectId", modelToLoad.get("id"));
      //     BticinoS4B.Instances.Models.ApplicationModel.set("projectName", modelToLoad.get("name"));
      //     BticinoS4B.Instances.Models.ApplicationModel.set("projectCreated", modelToLoad.get("creationDate"));
      //     BticinoS4B.Instances.Models.ApplicationModel.set("projectModified", modelToLoad.get("lastEditDate"));
      //     BticinoS4B.Instances.Models.ApplicationModel.trigger("change:projectName");
      //     window.BticinoS4B.eventAggregator.trigger("load:Project", jQuery.parseJSON(modelToLoad.get("content")));
      //     Popup.View.prototype.hide.apply(this);
      //   }
      //   window.BticinoS4B.eventAggregator.trigger("zoneValidityUpdate:request");
      //   this.hideLoader();
      // },

      deleteProject: function(modelToDelete) {
        var that = this;
        var ProjectToDeleteID = modelToDelete.get("id");
        var successCallback = function() {
          console.log('Project ' + ProjectToDeleteID + ' deleted');
        };
        window.BticinoS4B.Instances.Services.wizardServices.deleteProject(ProjectToDeleteID, successCallback);
      }
    });

    Header.RenameView = Popup.View.extend({
      className: "popup rename",
      template: "application/popups/rename",
      serialize: function() {
        return {
          app: app,
          model: this.model
        };
      },
      show: function() {
        this.render();
        Popup.View.prototype.show.apply(this);
      },

      closeButtonClickedEventHandler: function() {
        this.renameProject();
      },

      renameProject: function() {
        if (this.$el.find("input[name='projectName']").val() !== "") {
          var oldProjectName = BticinoS4B.Instances.Models.ApplicationModel.get("projectName");
          BticinoS4B.Instances.Models.ApplicationModel.set("projectName", this.$el.find("input[name='projectName']").val());
          window.BticinoS4B.eventAggregator.trigger("update:requested");
          Popup.View.prototype.hide.apply(this);
        }
      }
    });

    Header.InfoView = Popup.View.extend({
      className: "popup info",
      template: "application/popups/info",
      serialize: function() {
        return {
          app: app,
          model: this.model
        };
      },
      show: function() {
        this.render();
        Popup.View.prototype.show.apply(this);
      }
    });

    Header.LoaderView = Popup.View.extend({
      className: "popup loader",
      template: "application/popups/loader",
      serialize: function() {
        return {
          app: app,
          model: this.model
        };
      },
      show: function() {
        this.render();
        Popup.View.prototype.show.apply(this);
      },
      hide: function() {
        Popup.View.prototype.hide.apply(this);
      }
    });

    Header.SendMailView = Popup.View.extend({
      className: "popup sendmail",
      template: "application/popups/sendmail",
      serialize: function() {
        return {
          app: app,
          model: this.model
        };
      },
      show: function(callback) {
        this.callback = callback;
        this.render();
        Popup.View.prototype.show.apply(this);
      },
      hide: function() {
        Popup.View.prototype.hide.apply(this);
      },
      yesButtonClickedEventHandler: function() {
        var mail = document.getElementById("email").value;
        var msg = document.getElementById("textmsg").value;
        //console.log(mail);
        //console.log(msg);
        Popup.View.prototype.hide.apply(this);
        this.callback(mail, msg);
      },
      noButtonClickedEventHandler: function() {
        console.log('no');
        Popup.View.prototype.hide.apply(this);
      }
    });

    Header.LogoutView = Popup.View.extend({
      className: "popup logout",
      template: "application/popups/logout",
      serialize: function() {
        return {
          app: app,
          model: this.model
        };
      },
      show: function() {
        this.render();
        Popup.View.prototype.show.apply(this);
      },
      afterSaveProject: function() {
        window.BticinoS4B.eventAggregator.trigger("logout:requested");
      },
      yesButtonClickedEventHandler: function() {
        var callbackPopup = this.afterSaveProject,
          that = this;
        if (Header.View.prototype.isInsertedOneSystem()) {
          $('.confirmDescription').html($.i18n._("IDS_W1_9175"));
          $('.yesButton').click(function() {
            Header.SaveView.prototype.show.apply(that.__manager__.parent.savePopup, [null, callbackPopup, that]);
          });
          $('.noButton').click(function() {
            Popup.View.prototype.hide.apply(this);
            window.BticinoS4B.eventAggregator.trigger("logout:requested");
          });
        } else {
          Popup.View.prototype.hide.apply(this);
          window.BticinoS4B.eventAggregator.trigger("logout:requested");
        }

      },
      noButtonClickedEventHandler: function() {
        Popup.View.prototype.hide.apply(this);
      }
    });

    Header.RequestDataStorageView = Popup.View.extend({
      className: "popup requestDataStorage",
      template: "application/popups/requestDataStorage",
      serialize: function() {
        return {
          app: app,
          model: this.model
        };
      },
      show: function(openCallback, closeCallBack, scope) {
        this.render();
        Popup.View.prototype.show.apply(this, [openCallback, closeCallBack, scope]);
      },

      yesButtonClickedEventHandler: function() {
        //if (BticinoS4B.modelToLoad  == undefined) { window.BticinoS4B.modelToLoad = {}; }
        switch (window.BticinoS4B.Instances.Models.ApplicationModel.get('systemId')) {
          case '#2':
            BticinoS4B.modelToLoad.thermoregulation = window.BticinoS4B.Classes.calculationClassThermoregulation.retrieveModels();
            break;
          case '#4':
            BticinoS4B.modelToLoad.intrusionDetection = window.BticinoS4B.Classes.calculationClassIntrusionDetection.retrieveModels();
            break;
          case '#5+6':
            BticinoS4B.modelToLoad.audioVideo = window.BticinoS4B.Classes.calculationClassAudioVideo.retrieveModels();
            break;
          case '#13+20':
            BticinoS4B.modelToLoad.automation = window.BticinoS4B.Classes.calculationClassAutomation.retrieveModels();
            break;
          case '#13':
            BticinoS4B.modelToLoad.automationSimple = window.BticinoS4B.Classes.calculationClassAutomationSimple.retrieveModels();
            break;
          case '#21':
            BticinoS4B.modelToLoad.energyManagement = window.BticinoS4B.Classes.calculationClassEnergyManagement.retrieveModels();
            break;
        }
        //window.BticinoS4B.eventAggregator.trigger("logout:requested");
        Popup.View.prototype.hide.apply(this);
      },

      noButtonClickedEventHandler: function() {
        switch (window.BticinoS4B.Instances.Models.ApplicationModel.get('systemId')) {
          case '#2':
            window.BticinoS4B.modelToLoad.thermoregulation = null;
            window.BticinoS4B.solution.thermoregulation.inserted = false;
            break;
          case '#4':
            window.BticinoS4B.modelToLoad.intrusionDetection = null;
            window.BticinoS4B.solution.intrusionDetection.inserted = false;
            break;
          case '#5+6':
            window.BticinoS4B.modelToLoad.audioVideo = null;
            window.BticinoS4B.solution.audioVideo.inserted = false;
            break;
          case '#13+20':
            window.BticinoS4B.modelToLoad.automation = null;
            window.BticinoS4B.solution.automation.inserted = false;
            break;
          case '#13':
            window.BticinoS4B.modelToLoad.automationSimple = null;
            window.BticinoS4B.solution.automationSimple.inserted = false;
            break;
          case '#21':
            window.BticinoS4B.modelToLoad.energyManagement = null;
            window.BticinoS4B.solution.energyManagement.inserted = false;
            break;
        }
        Popup.View.prototype.hide.apply(this);
      }
    });


    Header.RequestProjectStorageView = Popup.View.extend({
      className: "popup requestProjectStorage",
      template: "application/popups/requestProjectStorage",
      serialize: function() {
        return {
          app: app,
          model: this.model
        };
      },
      show: function(openCallback, closeCallBack, scope) {
        this.render();
        Popup.View.prototype.show.apply(this, [openCallback, closeCallBack, scope]);
      },
      reloadProject: function() {
        var href = window.BticinoS4B.baseUrl;
        Backbone.history.navigate(href.slice(window.BticinoS4B.root.length), true);
        jQuery("#container section").remove();
        window.BticinoS4B.Instances.Models.QuoteTypesMenuModel.set('quoteTypeDefined', false);
        window.BticinoS4B.Instances.Models.QuoteTypesMenuModel.set('quoteType', undefined);
        window.BticinoS4B.Instances.Views.QuoteTypesMenuView.render();
        window.BticinoS4B.Instances.Views.QuoteTypesMenuView.resetSystem();
        window.BticinoS4B.Instances.Views.headerView.render();
      },
      yesButtonClickedEventHandler: function() {

        //window.BticinoS4B.eventAggregator.trigger("logout:requested");
        // Popup.View.prototype.hide.apply(this);
        var callbackProject = this.reloadProject;
        Header.SaveView.prototype.show.apply(this.__manager__.parent.savePopup, [null, callbackProject, this]);
      },

      noButtonClickedEventHandler: function() {
        Popup.View.prototype.hide.apply(this);
        this.reloadProject();
      }
    });

    Header.ImportView = Popup.View.extend({
      className: "popup load",
      template: "application/popups/import",
      events: {
        "keyup input[name='projectName']": "filterList"
      },

      initialize: function() {
        window.BticinoS4B.projects = new projectCollection([]);
        window.BticinoS4B.projects.bind("import:request", this.import, this);
        window.BticinoS4B.projects.bind("delete:request", this.deleteProject, this);
        //this.model.projects = projects;
      },

      retrieveData: function() {
        var that = this;
        window.BticinoS4B.projects.retrieveProjects(BticinoS4B.vars.systemToImport, true);
        _.each(window.BticinoS4B.projects.models, function(project) {
          that.insertView(".projects", new projectView({
            model: project,
            systemCode: that.systemCode
          }));
        });
      },

      showLoader: function(e) {
        $(this.$el.find("table")).hide();
        $(this.$el.find(".save")).hide();
        $(this.$el.find(".loader")).show();
      },

      hideLoader: function(e) {
        $(this.$el.find(".loader")).hide();
        $(this.$el.find("table")).show();
        $(this.$el.find(".save")).show();
      },

      filterList: function(e) {
        window.BticinoS4B.projects.filterByName(e.currentTarget.value);
      },

      setSystem: function(systemCode) {
        this.systemCode = systemCode;
      },

      show: function(callback) {
        this.render();
        this.retrieveData();
        this.render();
        Popup.View.prototype.show.apply(this, [null, callback, this]);
      },

      import: function(modelToLoad) {
        var that = this;
        //var projectName = modelToLoad.get("name");
        that.showLoader();
        //window.BticinoS4B.eventAggregator.trigger("modelDeliver:request",this);
        if (modelToLoad) {
          //alert('import: function(modelToLoad)');

          window.BticinoS4B.eventAggregator.trigger("import:Project", jQuery.parseJSON(modelToLoad.get("content")));
          Popup.View.prototype.hide.apply(that);
        }
        window.BticinoS4B.eventAggregator.trigger("zoneValidityUpdate:request");
        that.hideLoader();
      }
    });

    Header.actuatorWizardView = Popup.View.extend({
      className: "popup actuatorWizard",
      template: "application/popups/actuatorWizardChoice",
      events: {
        "click #btnCompare"     : "compareEventHandler",
        "click #btnbackToChoice": "backToChoiceEventHandler",
        "click #btnPrint"       : "printEventHandler",
        "click .buttonBig"      : "awFilterTypeEventHandler",
        "click .awFilterLoad"   : "awFilterLoadEventHandler",
        "click .typeOfLight-1"  : "typeOfLightEventHandler",
        "click .isSlave"        : "checkBoxSlaveEventHandler",
        "click .add-actuator"   : "addActuatorEventHandler",
        "click .btnCompareItem" : "addItemToCompareEventHandler"
      },

      serialize: function() {
        return {
          app: app,
          model: this.model
        };
      },

      initialize: function() {
        this.model.bind('packages:updated', this.updateResult, this);
      },

      resetValues: function(){
        this.model.resetValues();
      },

      setCallBack: function(func, scope) {
        this.model.set('callback', func);
        this.model.set('callbackScope', scope);
      },

      addActuatorEventHandler: function(e) {
        var packageClassId = e.currentTarget.id;
        this.model.setPackageToAdd(packageClassId);
        //alert('add');
        //this.model.get('callback');
        Popup.View.prototype.hide.apply(this);
      },

      backToChoiceEventHandler: function() {
        this.changeTemplate('choice');
      },

      printEventHandler: function() {
        var mywindow = window.open('', 'Confronto attuatori', 'height=400, width=960');
        mywindow.document.writeln('<html><head><title>Confronto attuatori</title>');
        /*optional stylesheet*/
        mywindow.document.write('<link rel="stylesheet" href="./assets/css/style.css" type="text/css" />');
        mywindow.document.write('</head><body>');
        mywindow.document.write('<table id="compareTable">' + this.$el.find("#compareTable").html() + '</table>');
        mywindow.document.write('</body></html>');
        //console.log(mywindow.document.body);
        window.setTimeout(function(){
          console.log('wait for print');
          mywindow.print();
          mywindow.close();}, 1000);        
      },

      addItemToCompareEventHandler: function(e) {
        var packageClassId = e.target.value,
            idx = this.model.get('comparedPackagesId').indexOf(packageClassId);

        if (idx == -1)
        {
          //add PackageCLassId
          this.model.get('comparedPackagesId').push(packageClassId);
        }
        else
        {
          //remove PackageCLassId
          this.model.get('comparedPackagesId').splice(idx, 1);
        }

        this.checkButtonCompareStatus();
      },

      checkButtonCompareStatus: function() {
        if (this.model.get('comparedPackagesId').length<2) {
          $(this.$el.find("#btnCompare")).addClass('disabled');
        } else {
          $(this.$el.find("#btnCompare")).removeClass('disabled');
        }
      },

      compareEventHandler: function(e) {
        var className = (e.target.className).trim();
        if (className.indexOf('disabled')>-1) {
          alert('Selezionare almeno 2 elementi prima di procedere con il confronto degli attuatori');
        }
        else {
          this.changeTemplate('compare');
        }
      },

      changeTemplate: function(activity) {
        if (activity == 'choice') {
          this.template = 'application/popups/actuatorWizardChoice';
        } else if (activity == 'compare') {
          this.model.setComparedPackages();
          this.template = 'application/popups/actuatorWizardCompare';
        }
        this.render();
        Popup.View.prototype.show.apply(this);
      },

      filteringConfiguration: function(filterTypeOfLight, filterIsSlave) {
        this.model.set('filterProperty', filterTypeOfLight);
        this.model.set('filterSlave', filterIsSlave);
      },

      typeOfLightEventHandler: function(e) {
        var targetValue = e.target.value;
        this.model.set('filterProperty', targetValue);
        //console.log(targetValue);
      },

      checkBoxSlaveEventHandler: function(e) {
        var targetValue = e.target.checked;
        this.model.set('filterSlave', targetValue);
      },

      awFilterTypeEventHandler: function(e) {
        var targetName = e.target.attributes['typeId'].value;
        //console.log('awFilter1EventHandler');
        var filter = this.model.get('filterType');
        var idx = filter ? filter.indexOf(targetName) : -1;

        if (targetName !=='') {
          if (idx == -1) {
            //update model
            filter.push(targetName);
            this.model.set('filterType', filter);
            //update view
            $(this.$el.find("#" + targetName)).addClass('selected');
          } else {
            //update model
            filter.splice(idx, 1);
            this.model.set('filterType', filter);
            //update view
            $(this.$el.find("#" + targetName)).removeClass('selected');
          }
          this.model.trigger('change:filterType');
        }
      },
      
      awFilterLoadEventHandler: function(e){
        var targetName = e.target.attributes['loadId'].value;

        var filter = this.model.get('filterLoad');
        var idx = filter ? filter.indexOf(targetName) : -1;

        if (targetName !=='') {
          if (idx == -1) {
            //update model
            filter.push(targetName);
            this.model.set('filterLoad', filter);
            //update view
            $(this.$el.find("#" + targetName)).addClass('selected');
          } else {
            //update model
            filter.splice(idx, 1);
            this.model.set('filterLoad', filter);
            //update view
            $(this.$el.find("#" + targetName)).removeClass('selected');
          }
          this.model.trigger('change:filterLoad');
        }
      },

      show: function() {
        this.model.set('packageToAdd', undefined);
        this.model.set('packagesFetched', false);
        this.model.fetchPackages();
        this.render();
        Popup.View.prototype.show.apply(this);
      },

      updateResult: function() {
        var that = this;
        //console.log($(this.$el.find("#cboxLoadedContent")));
        that.render();
        Popup.View.prototype.show.apply(this);
        //console.log($(this.$el.find("#cboxLoadedContent")));
      },

      afterRender: function(){
        //console.log('afterRender');
      },

      hide: function() {
        Popup.View.prototype.hide.apply(this);
      }
    });

    // Header Views
    // ----------
    Header.View = Backbone.View.extend({
      keep: true,
      tagName: "header",
      template: "application/header",
      events: {
        "click .project-button": "projectButtonClicked",
        "click .save-button-header": "saveHeaderButtonClicked",
        "click .save-button-singlefunction": "saveButtonSingleFunctionClicked",
        "click .save-button-multifunction": "saveButtonMultiFunctionClicked",
        "click .printReport-button": "printReportButtonClicked",
        "click .language-menu-button": "languageMenuButtonClicked",
        "click .open-button": "openButtonClicked",
        "click .save-button": "saveButtonClicked",
        "click .saveAs-button": "saveAsButtonClicked",
        "click .delete-button": "deleteButtonClicked",
        "click .rename-button": "renameButtonClicked",
        "click .info-button": "infoButtonClicked",
        "click .new-button": "newButtonClicked",
        "click .logout-button": "logoutButtonClicked",
        "click .language-button": "languageButtonClicked",
        "click .returnSistemiDomoticiButtonActive": "sistemiDomoticiButtonClicked",
        "click .returnQuoteTypesButton": "quoteTypesButtonClicked",
        "click .export-global-materiallist-button": "exportGlobalMaterialList",
        "click .forward-project-button": "forwardProjectByEmail",
        // "click .export-global-configuration-button": "exportGlobalConfiguration",
        "mouseenter .submenu li": "preventBubbling",
        "mouseout  .submenu": "fadeOutProjectMenu",
        "mouseleave .language-menu": "fadeOutLanguageMenu",
        "mouseenter .project-button": "enlightProjectButton",
        "mouseleave .project-button": "deEnlightProjectButton",
        "mouseenter .printReport-button": "enlightPrintReportButton",
        "mouseleave .printReport-button": "deEnlightPrintReportButton",
        "mouseout  .submenu-printReport": "fadeOutPrintReportMenu",
        "mouseout .save-button-header": "fadeOutSaveMenu",
        "mouseenter .returnQuoteTypesButton": "enlightQuoteTypeButton",
        "mouseleave .returnQuoteTypesButton": "deEnlightQuoteTypeButton",
        "mouseenter .language-menu-button": "enlightLanguageButton",
        "mouseleave .language-menu-button": "deEnlightLanguageButton",
        "mouseenter .new-button": "enlightNewButton",
        "mouseleave .new-button": "deEnlightNewButton",
        "mouseenter .open-button": "enlightLoadButton",
        "mouseleave .open-button": "deEnlightLoadButton",
        "mouseenter .save-button": "enlightSaveButton",
        "mouseleave .save-button": "deEnlightSaveButton",
        "mouseenter .saveAs-button": "enlightSaveAsButton",
        "mouseleave .saveAs-button": "deEnlightSaveAsButton",
        "mouseenter .delete-button": "enlightDeleteButton",
        "mouseleave .delete-button": "deEnlightDeleteButton",
        "mouseenter .rename-button": "enlightRenameButton",
        "mouseleave .rename-button": "deEnlightRenameButton",
        "mouseenter .info-button": "enlightInfoButton",
        "mouseleave .info-button": "deEnlightInfoButton"
      },
      checkToken: function() {
        BticinoS4B.checkTokenCookie();
      },

      serialize: function() {
        return {
          app: app,
          options: this.options,
          model: this.model
        };
      },

      initialize: function() {

        var that = this;

        this.model = new Header.Model();

        BticinoS4B.Instances.Models.ApplicationModel.unbind("change:projectName", this.updateProjectName);
        BticinoS4B.Instances.Models.ApplicationModel.bind("change:projectName", this.updateProjectName, this);

        BticinoS4B.Instances.Models.ApplicationModel.unbind("change:projectId", this.render);
        BticinoS4B.Instances.Models.ApplicationModel.bind("change:projectId", this.render, this);

        if (BticinoS4B.Instances.Models.loginModel.isAuthenticated())
          window.BticinoS4B.eventAggregator.unbind("language:changed", null);
        window.BticinoS4B.eventAggregator.bind("language:changed", this.render, this);

        var chosenSystem = _.filter(BticinoS4B.Instances.Models.ApplicationModel.get("systems"), function(system) {
          return (system.id === that.options.systemId);
        });

        if (chosenSystem.length > 0) {
          this.model.set("systemName", $.i18n._(chosenSystem[0].name));
          this.model.set("systemAppName", chosenSystem[0].appName);
        }
      },

      updateProjectName: function() {
        if ((BticinoS4B.Instances.Models.ApplicationModel.get("projectName")) && (BticinoS4B.Instances.Models.ApplicationModel.get("projectName") !== ""))
          $(this.$el.find(".userDatas")[0]).html(BticinoS4B.Instances.Models.loginModel.get("username") + " - " + BticinoS4B.Instances.Models.ApplicationModel.get("projectName"));
        else
          $(this.$el.find(".userDatas")[0]).html(BticinoS4B.Instances.Models.loginModel.get("username"));
      },

      preventBubbling: function(e) {
        e.stopPropagation();
      },

      logoutButtonClicked: function() {
        this.logoutPopup.show(true);
      },

      openButtonClicked: function() {
        this.checkToken();
        this.loadPopup.show();
      },

      saveButtonClicked: function() {
        this.checkToken();
        this.savePopup.show();
      },
      triggerSaveAs: function() {
        window.BticinoS4B.eventAggregator.trigger("language:changed");
      },

      saveAsButtonClicked: function() {
        this.checkToken();
        this.savePopup.show(true, this.triggerSaveAs);
      },

      newButtonClicked: function() {
        this.checkToken();
        var locationHref = window.location.href,
          locationPath = window.location.pathname;

        window.location.assign(locationHref.replace(locationPath, ''));
      },

      deleteButtonClicked: function() {
        this.checkToken();
        if (BticinoS4B.Instances.Models.ApplicationModel.get("projectId")) {
          if (confirm($.i18n._("IDS_W1_9088"))) {
            $.ajax({
              type: "POST",
              datatype: "json",
              contentType: "application/json",
              url: "/WizardService.svc/deleteProject",
              data: JSON.stringify({
                token: window.BticinoS4B.token,
                projectId: BticinoS4B.Instances.Models.ApplicationModel.get("projectId")
              }),
              success: function() {
                BticinoS4B.Instances.Models.ApplicationModel.set("projectName", undefined);
                BticinoS4B.Instances.Models.ApplicationModel.set("projectId", undefined);
              }
            });
          }
        }
      },

      renameButtonClicked: function() {
        this.checkToken();
        if (BticinoS4B.Instances.Models.ApplicationModel.get("projectId")) {
          this.renamePopup.show();
        }
      },

      infoButtonClicked: function() {
        this.checkToken();
        if (BticinoS4B.Instances.Models.ApplicationModel.get("projectId")) {
          this.infoPopup.show();
        }
      },

      languageButtonClicked: function(e) {
        this.checkToken();
        var newLanguage = $(e.target).find("p").text();
        if (newLanguage === "")
          newLanguage = $(e.target).text();

        if ((newLanguage !== "") && (BticinoS4B.Instances.Models.ApplicationModel.get("currentLanguage") !== newLanguage)) {

          BticinoS4B.Instances.Models.ApplicationModel.set("currentLanguage", newLanguage);
          moment.lang(newLanguage, momentStrings[newLanguage]);
          moment.lang(newLanguage);
          window.BticinoS4B.eventAggregator.trigger("language:changed", BticinoS4B.Instances.Models.ApplicationModel.get("currentLanguage"));
        } else {
          e.stopPropagation();
        }
      },

      printReportButtonClicked: function() {
        this.checkToken();
        if (!this.$el.find(".printReport-button").is(".selected")) {
          this.$el.find(".printReport-button").addClass("selected");
          this.$el.find(".submenu-printReport").fadeIn(200);
        } else {
          this.$el.find(".printReport-button").removeClass("selected");
          this.$el.find(".submenu-printReport").fadeOut(200);
        }
      },

      projectButtonClicked: function() {
        this.checkToken();
        if (!this.$el.find(".project-button").is(".selected")) {
          this.$el.find(".project-button").addClass("selected");
          this.$el.find(".submenu").fadeIn(200);
        } else {
          this.$el.find(".project-button").removeClass("selected");
          this.$el.find(".submenu").fadeOut(200);
        }
      },

      saveHeaderButtonClicked: function() {
        this.checkToken();
        if (!this.$el.find(".save-button-header").is(".selected")) {
          this.$el.find(".save-button-header").addClass("selected");
          this.$el.find(".submenu-savechoice").fadeIn(200);
        } else {
          this.$el.find(".save-button-header").removeClass("selected");
          this.$el.find(".submenu-savechoice").fadeOut(200);
        }
      },

      saveButtonSingleFunctionClicked: function() {
        this.checkToken();
        this.saveSinglePopup.show();
      },

      saveButtonMultiFunctionClicked: function() {
        this.checkToken();
        this.savePopup.show();
      },

      languageMenuButtonClicked: function(e) {
        this.checkToken();
        if (!this.$el.find(".language-button").is(".selected")) {
          this.$el.find(".language-button").addClass("selected");
          this.$el.find(".language-menu").fadeIn(200);
        } else {
          this.$el.find(".language-button").removeClass("selected");
          this.$el.find(".language-menu").fadeOut(200);
        }
      },

      fadeOutProjectMenu: function(e) {
        if (!$.contains(this.el, e.relatedTarget)) {
          this.$el.find(".project-button").removeClass("selected");
          this.$el.find(".submenu").fadeOut(200);
        }
      },

      fadeOutPrintReportMenu: function(e) {
        if (!$.contains(this.el, e.relatedTarget)) {
          this.$el.find(".printReport-button").removeClass("selected");
          this.$el.find(".submenu-printReport").fadeOut(200);
        }
      },

      fadeOutSaveMenu: function(e) {
        if (!$.contains(this.el, e.relatedTarget)) {
          this.$el.find(".save-button-header").removeClass("selected");
          this.$el.find(".submenu-savechoice").fadeOut(200);
        }
      },

      fadeOutLanguageMenu: function(e) {
        if (!$.contains(this.el, e.relatedTarget)) {
          this.$el.find(".language-button").removeClass("selected");
          this.$el.find(".language-menu").fadeOut(200);
        }
      },

      enlightProjectButton: function() {
        this.$el.find(".project-button .icon").attr("src", "/assets/img/project-icon-white.png");
        this.$el.find(".project-button .arrow").attr("src", "/assets/img/arrow-down-white.png");
      },

      deEnlightProjectButton: function() {
        this.$el.find(".project-button .icon").attr("src", "/assets/img/project-icon.png");
        this.$el.find(".project-button .arrow").attr("src", "/assets/img/arrow-down.png");
      },

      enlightPrintReportButton: function() {
        // this.$el.find(".printReport-button .icon").attr("src", "/assets/img/project-icon-white.png");
        this.$el.find(".printReport-button .arrow").attr("src", "/assets/img/arrow-down-white.png");
      },

      deEnlightPrintReportButton: function() {
        // this.$el.find(".printReport-button .icon").attr("src", "/assets/img/project-icon.png");
        this.$el.find(".printReport-button .arrow").attr("src", "/assets/img/arrow-down.png");
      },

      enlightQuoteTypeButton: function() {
        this.$el.find(".returnQuoteTypesButton img").attr("src", "/assets/img/icon-goHome-white.png");
      },

      deEnlightQuoteTypeButton: function() {
        this.$el.find(".returnQuoteTypesButton img").attr("src", "/assets/img/icon-goHome.png");
      },

      enlightLanguageButton: function() {
        this.$el.find("img.arrow").attr("src", "/assets/img/arrow-down-white.png");
      },

      deEnlightLanguageButton: function() {
        this.$el.find("img.arrow").attr("src", "/assets/img/arrow-down.png");
      },

      enlightNewButton: function(e) {
        this.$el.find(".new-button .icon").attr("src", "/assets/img/blank-icon-white.png");
      },

      deEnlightNewButton: function(e) {
        this.$el.find(".new-button .icon").attr("src", "/assets/img/blank-icon.png");
      },

      enlightLoadButton: function(e) {
        this.$el.find(".open-button .icon").attr("src", "/assets/img/folder-icon-white.png");
      },

      deEnlightLoadButton: function(e) {
        this.$el.find(".open-button .icon").attr("src", "/assets/img/folder-icon.png");
      },

      enlightSaveButton: function(e) {
        this.$el.find(".save-button .icon").attr("src", "/assets/img/floppy-icon-white.png");
      },

      deEnlightSaveButton: function(e) {
        this.$el.find(".save-button .icon").attr("src", "/assets/img/floppy-icon.png");
      },

      enlightSaveAsButton: function(e) {
        this.$el.find(".saveAs-button .icon").attr("src", "/assets/img/floppy-icon-white.png");
      },

      deEnlightSaveAsButton: function(e) {
        this.$el.find(".saveAs-button .icon").attr("src", "/assets/img/floppy-icon.png");
      },

      enlightDeleteButton: function(e) {
        if (BticinoS4B.Instances.Models.ApplicationModel.get("projectId"))
          this.$el.find(".delete-button .icon").attr("src", "/assets/img/cross-icon-white.png");
      },

      deEnlightDeleteButton: function(e) {
        if (BticinoS4B.Instances.Models.ApplicationModel.get("projectId"))
          this.$el.find(".delete-button .icon").attr("src", "/assets/img/cross-icon.png");
      },

      enlightRenameButton: function(e) {
        if (BticinoS4B.Instances.Models.ApplicationModel.get("projectId"))
          this.$el.find(".rename-button .icon").attr("src", "/assets/img/type-icon-white.png");
      },

      deEnlightRenameButton: function(e) {
        if (BticinoS4B.Instances.Models.ApplicationModel.get("projectId"))
          this.$el.find(".rename-button .icon").attr("src", "/assets/img/type-icon.png");
      },

      enlightInfoButton: function(e) {
        if (BticinoS4B.Instances.Models.ApplicationModel.get("projectId"))
          this.$el.find(".info-button .icon").attr("src", "/assets/img/info-menu-icon-white.png");
      },

      deEnlightInfoButton: function(e) {
        if (BticinoS4B.Instances.Models.ApplicationModel.get("projectId"))
          this.$el.find(".info-button .icon").attr("src", "/assets/img/info-menu-icon.png");
      },

      sistemiDomoticiButtonClicked: function() {

        var generateDataFromProvider = function() {
            var that = this,
              dataProvider = BticinoS4B.Instances.Models.ApplicationModel.get("wizardModel").get("dataProvider");
            window.BticinoS4B.eventAggregator.trigger("modelDeliver:request", this);
            BticinoS4B.Instances.Models.ApplicationModel.startAutomaticCalculation();

            var dataToSend = {};

            //ItemListByPackage
            dataToSend.itemListByPackage = dataProvider.retrieveMaterialOverviewInReportVersion();

            //ItemListByProduct
            dataToSend.itemListByProduct = {
              productInPriceList: {
                section: $.i18n._("IDS_W1_9034"),
                items: []
              },
              productNotInPriceList: {
                section: $.i18n._("IDS_W1_9094"),
                items: []
              }
            };

            var materialList = dataProvider.retrieveMaterialListInReportVersion();
            dataToSend.itemListByProduct.productInPriceList.items = materialList.productsInPriceList;
            dataToSend.itemListByProduct.productNotInPriceList.items = materialList.productsNotInPriceList;

            dataToSend.grandTotal = dataProvider.getGrandTotal();

            return dataToSend;
          },
          sistemiDomoticiSuccessCallback = function() {
            var href = window.BticinoS4B.baseUrl + 'system-selection-multi';
            Backbone.history.navigate(href.slice(window.BticinoS4B.root.length), true);
          },

          unbindApplicationEventAggregator = function() {
            window.BticinoS4B.eventAggregator.unbind('configurationOverview:requested');
            window.BticinoS4B.eventAggregator.unbind('export:requested');
            //unbind all consumptionIndicator - currentDeliver
            window.BticinoS4B.eventAggregator.unbind('currentDeliver:requested');
            window.BticinoS4B.eventAggregator.unbind('kit:added');
            window.BticinoS4B.eventAggregator.unbind('removeKitItems');
            //unbind all zone events
            window.BticinoS4B.eventAggregator.unbind('zone:selected');
            window.BticinoS4B.eventAggregator.unbind('zoneDetail:render');
            window.BticinoS4B.eventAggregator.unbind('zoneStep:show');
            window.BticinoS4B.eventAggregator.unbind('zone:selectionRequested');
            window.BticinoS4B.eventAggregator.unbind('zoneStatusCheck:requested');
            window.BticinoS4B.eventAggregator.unbind('zoneValidityUpdate:request');
            //unbind all model retrieve
            window.BticinoS4B.eventAggregator.unbind('modelDeliver:request');
            window.BticinoS4B.eventAggregator.unbind('load:Project');
          },

          clearApplicationModelVariables = function() {
            delete BticinoS4B.Instances.Models.ApplicationModel.attributes.additionalZones;
            delete BticinoS4B.Instances.Models.ApplicationModel.attributes.advancedCommands;
            delete BticinoS4B.Instances.Models.ApplicationModel.attributes.amplifierAndLoudSpeakers;
            delete BticinoS4B.Instances.Models.ApplicationModel.attributes.amplifierAndLoudSpeakersCollectionLength;
            delete BticinoS4B.Instances.Models.ApplicationModel.attributes.amplifierCommand;
            delete BticinoS4B.Instances.Models.ApplicationModel.attributes.apartmentInterface;
            delete BticinoS4B.Instances.Models.ApplicationModel.attributes.apartmentInterfaceItems;
            delete BticinoS4B.Instances.Models.ApplicationModel.attributes.audioVideoSystemSelectionAndPowerSupply;
            delete BticinoS4B.Instances.Models.ApplicationModel.attributes.automaticCalculationModel;
            delete BticinoS4B.Instances.Models.ApplicationModel.attributes.automaticProducts;
            delete BticinoS4B.Instances.Models.ApplicationModel.attributes.automationSystemSelection;
            delete BticinoS4B.Instances.Models.ApplicationModel.attributes.choosenDistributionSystem;
            delete BticinoS4B.Instances.Models.ApplicationModel.attributes.choosenSystems;
            delete BticinoS4B.Instances.Models.ApplicationModel.attributes.commandPoints;
            delete BticinoS4B.Instances.Models.ApplicationModel.attributes.commandPointsLength;
            delete BticinoS4B.Instances.Models.ApplicationModel.attributes.commands;
            delete BticinoS4B.Instances.Models.ApplicationModel.attributes.completeConfiguration;
            delete BticinoS4B.Instances.Models.ApplicationModel.attributes.configurationModel;
            delete BticinoS4B.Instances.Models.ApplicationModel.attributes.configurationProductsFromKit;
            delete BticinoS4B.Instances.Models.ApplicationModel.attributes.consumptionIndicatorModel;
            delete BticinoS4B.Instances.Models.ApplicationModel.attributes.controlledLoads;
            delete BticinoS4B.Instances.Models.ApplicationModel.attributes.controlledLoadsLength;
            delete BticinoS4B.Instances.Models.ApplicationModel.attributes.conversationMaxExtraConsumption;
            delete BticinoS4B.Instances.Models.ApplicationModel.attributes.engines;
            delete BticinoS4B.Instances.Models.ApplicationModel.attributes.enginesAddressesLength;
            delete BticinoS4B.Instances.Models.ApplicationModel.attributes.enginesLength;
            delete BticinoS4B.Instances.Models.ApplicationModel.attributes.enginesMultipleActuatorsLength;
            delete BticinoS4B.Instances.Models.ApplicationModel.attributes.externalItems;
            delete BticinoS4B.Instances.Models.ApplicationModel.attributes.filterId;
            delete BticinoS4B.Instances.Models.ApplicationModel.attributes.gaugesAndInterfaces;
            delete BticinoS4B.Instances.Models.ApplicationModel.attributes.gaugesAndInterfacesLength;
            delete BticinoS4B.Instances.Models.ApplicationModel.attributes.grandTotal;
            delete BticinoS4B.Instances.Models.ApplicationModel.attributes.handsetCollectionLength;
            delete BticinoS4B.Instances.Models.ApplicationModel.attributes.handsets;
            delete BticinoS4B.Instances.Models.ApplicationModel.attributes.inserters;
            delete BticinoS4B.Instances.Models.ApplicationModel.attributes.integrationDevices;
            delete BticinoS4B.Instances.Models.ApplicationModel.attributes.internals;
            delete BticinoS4B.Instances.Models.ApplicationModel.attributes.keyCoversFromKit;
            delete BticinoS4B.Instances.Models.ApplicationModel.attributes.kits;
            delete BticinoS4B.Instances.Models.ApplicationModel.attributes.lastAutomaticProductsRetrieved;
            delete BticinoS4B.Instances.Models.ApplicationModel.attributes.lastConfiguration;
            delete BticinoS4B.Instances.Models.ApplicationModel.attributes.lastModelSentToConfigurationService;
            delete BticinoS4B.Instances.Models.ApplicationModel.attributes.lastModelSentToOptimizationService;
            delete BticinoS4B.Instances.Models.ApplicationModel.attributes.lightPoints;
            delete BticinoS4B.Instances.Models.ApplicationModel.attributes.lightPointsAddressesLength;
            delete BticinoS4B.Instances.Models.ApplicationModel.attributes.lightPointsLength;
            delete BticinoS4B.Instances.Models.ApplicationModel.attributes.lightPointsMultipleActuatorsLength;
            delete BticinoS4B.Instances.Models.ApplicationModel.attributes.mainCommandCollectionLength;
            delete BticinoS4B.Instances.Models.ApplicationModel.attributes.mainControlUnit;
            delete BticinoS4B.Instances.Models.ApplicationModel.attributes.mainControlUnitModel;
            delete BticinoS4B.Instances.Models.ApplicationModel.attributes.maxDerivates;
            delete BticinoS4B.Instances.Models.ApplicationModel.attributes.maxExtraConsumption;
            delete BticinoS4B.Instances.Models.ApplicationModel.attributes.maxNonPoweredVct;
            delete BticinoS4B.Instances.Models.ApplicationModel.attributes.maxSources;
            delete BticinoS4B.Instances.Models.ApplicationModel.attributes.maxVde;
            delete BticinoS4B.Instances.Models.ApplicationModel.attributes.maxZoneNumber;
            delete BticinoS4B.Instances.Models.ApplicationModel.attributes.memoryModuleQuantity;
            delete BticinoS4B.Instances.Models.ApplicationModel.attributes.numberOfApartmentInterface;
            delete BticinoS4B.Instances.Models.ApplicationModel.attributes.optionalPackages;
            delete BticinoS4B.Instances.Models.ApplicationModel.attributes.outerRadioProbe;
            delete BticinoS4B.Instances.Models.ApplicationModel.attributes.percentageOfTotalCurrentConsumption;
            delete BticinoS4B.Instances.Models.ApplicationModel.attributes.plainPackages;
            delete BticinoS4B.Instances.Models.ApplicationModel.attributes.powerSupply;
            delete BticinoS4B.Instances.Models.ApplicationModel.attributes.powerSupplyId;
            delete BticinoS4B.Instances.Models.ApplicationModel.attributes.pumps;
            delete BticinoS4B.Instances.Models.ApplicationModel.attributes.quote;
            delete BticinoS4B.Instances.Models.ApplicationModel.attributes.radioSystemPresent;
            delete BticinoS4B.Instances.Models.ApplicationModel.attributes.radioSystems;
            delete BticinoS4B.Instances.Models.ApplicationModel.attributes.remoteControls;
            delete BticinoS4B.Instances.Models.ApplicationModel.attributes.scenarioDinModuleQuantity;
            delete BticinoS4B.Instances.Models.ApplicationModel.attributes.scenariosCommands;
            delete BticinoS4B.Instances.Models.ApplicationModel.attributes.scenarioStatus;
            delete BticinoS4B.Instances.Models.ApplicationModel.attributes.sirens;
            delete BticinoS4B.Instances.Models.ApplicationModel.attributes.soundDiffusionMaxExtraConsumption;
            delete BticinoS4B.Instances.Models.ApplicationModel.attributes.sources;
            delete BticinoS4B.Instances.Models.ApplicationModel.attributes.sourcesCollectionLength;
            delete BticinoS4B.Instances.Models.ApplicationModel.attributes.sourcesItems;
            delete BticinoS4B.Instances.Models.ApplicationModel.attributes.technicalBusAlarm;
            delete BticinoS4B.Instances.Models.ApplicationModel.attributes.technicalBusAlarmLength;
            delete BticinoS4B.Instances.Models.ApplicationModel.attributes.technicalRadioAlarm;
            delete BticinoS4B.Instances.Models.ApplicationModel.attributes.technicalRadioAlarmLength;
            delete BticinoS4B.Instances.Models.ApplicationModel.attributes.telephony;
            delete BticinoS4B.Instances.Models.ApplicationModel.attributes.telephonyReservedPositions;
            delete BticinoS4B.Instances.Models.ApplicationModel.attributes.traditionals;
            delete BticinoS4B.Instances.Models.ApplicationModel.attributes.traditionalsLength;
            delete BticinoS4B.Instances.Models.ApplicationModel.attributes.trafoFound;
            delete BticinoS4B.Instances.Models.ApplicationModel.attributes.vdes;
            delete BticinoS4B.Instances.Models.ApplicationModel.attributes.vdesCollectionLength;
            delete BticinoS4B.Instances.Models.ApplicationModel.attributes.vdesItems;
            delete BticinoS4B.Instances.Models.ApplicationModel.attributes.vpeDevices;
            delete BticinoS4B.Instances.Models.ApplicationModel.attributes.vpeDevicesCollectionLength;
            delete BticinoS4B.Instances.Models.ApplicationModel.attributes.webServer;
            delete BticinoS4B.Instances.Models.ApplicationModel.attributes.zigbeeCommandsQuantity;
            delete BticinoS4B.Instances.Models.ApplicationModel.attributes.zigbeeInterfaceQuantity;
            delete BticinoS4B.Instances.Models.ApplicationModel.attributes.zigbeeRadio;
            delete BticinoS4B.Instances.Models.ApplicationModel.attributes.zigbeeRadioLength;
            delete BticinoS4B.Instances.Models.ApplicationModel.attributes.zigbeeStatus;
            delete BticinoS4B.Instances.Models.ApplicationModel.attributes.zoneInserted;
            delete BticinoS4B.Instances.Models.ApplicationModel.attributes.zoneLength;
            delete BticinoS4B.Instances.Models.ApplicationModel.attributes.zones;
            delete BticinoS4B.Instances.Models.ApplicationModel.attributes.zonesItems;
            delete BticinoS4B.Instances.Models.ApplicationModel.attributes.zonesWithoutOneFreePProtection;
          };

        this.checkToken();
        /*
         switch (BticinoS4B.vars.system.id) {
           case '#2':
             window.BticinoS4B.modelToExport.thermoregulation = generateDataFromProvider();
             break;
           case '#4':
             window.BticinoS4B.modelToExport.intrusionDetection = generateDataFromProvider();
             break;
           case '#5+6':
             window.BticinoS4B.modelToExport.audioVideo = generateDataFromProvider();
             break;
           case '#13+20':
             window.BticinoS4B.modelToExport.automation = generateDataFromProvider();
             break;
         }
        */
        //alert('(r:1127) Richiesta salvataggio');
        clearApplicationModelVariables();
        unbindApplicationEventAggregator();

        if (this.isValidSystem() && !window.BticinoS4B.Instances.Models.ApplicationModel.get("alreadySaved")) {
          this.requestDataStoragePopup.show(null, sistemiDomoticiSuccessCallback, this);
        } else {
          sistemiDomoticiSuccessCallback();
          //var href = window.BticinoS4B.baseUrl + 'system-selection-multi';
          //Backbone.history.navigate(href.slice(window.BticinoS4B.root.length), true);
        }
      },

      isValidSystem: function() {
        if (window.BticinoS4B.Instances.Models.ApplicationModel.get("systemId"))
          switch (window.BticinoS4B.Instances.Models.ApplicationModel.get("systemId")) {
            case '#2':
              return window.BticinoS4B.solution.thermoregulation.inserted;
            case '#4':
              return window.BticinoS4B.solution.intrusionDetection.inserted;
            case '#5+6':
              return window.BticinoS4B.solution.audioVideo.inserted;
            case '#13+20':
              return window.BticinoS4B.solution.automation.inserted;
            case '#13':
              return window.BticinoS4B.solution.automationSimple.inserted;
            case '#21':
              return window.BticinoS4B.solution.energyManagement.inserted;
            default:
              return false;
          } else
            return false;
      },

      quoteTypesButtonClicked: function() {
        var locationHref,
          locationPath,
          requestProjectStorageCallback = function() {
            window.BticinoS4B.Instances.Models.QuoteTypesMenuModel.set('quoteTypeDefined', false);
            window.BticinoS4B.Instances.Models.QuoteTypesMenuModel.set('quoteType', undefined);
          };

        this.checkToken();
        //alert('(r:1141) Richiesta salvataggio'); 
        if (this.isInsertedOneSystem())
          this.requestProjectStoragePopup.show(null, requestProjectStorageCallback, this);
        else {
          requestProjectStorageCallback();
          var href = window.BticinoS4B.baseUrl;
          Backbone.history.navigate(href.slice(window.BticinoS4B.root.length), true);
          jQuery("#container section").remove();
          window.BticinoS4B.Instances.Views.QuoteTypesMenuView.render();
          window.BticinoS4B.Instances.Views.QuoteTypesMenuView.resetSystem();
          window.BticinoS4B.Instances.Views.headerView.render();
        }
      },

      exportGlobalMaterialList: function() {
        var exportSolution = ExportSolutionMaterialList;
        this.loaderPopup.show();
        exportSolution.generateReport();
        //window.BticinoS4B.eventAggregator.trigger("exportSolutionMaterialList:requested");
        /*
        var that = this,
          dataToSend = {},
          grandTotal = 0,
          k = 0,
          i = 0,
          exportDataProvider = BticinoS4B.Instances.Models.ApplicationModel.get("wizardModel").get("dataProvider") ? BticinoS4B.Instances.Models.ApplicationModel.get("wizardModel").get("dataProvider") : new DataProvider(),
          
          addItemListByPackageExternalItems = function(externalItems){
            if (dataToSend.itemListByPackage.externalItems.section){
              for (i = 0; i < externalItems.data.length; i++) {
                dataToSend.itemListByPackage.externalItems.data.push(externalItems.data[i]);
              }
            }
            else {
              dataToSend.itemListByPackage.externalItems = externalItems;
            }
          },

          addItemListByPackageAutomaticItems = function(automaticItems){
            if (dataToSend.itemListByPackage.automaticItems.section){
              for (i = 0; i < automaticItems.data.length; i++) {
                dataToSend.itemListByPackage.automaticItems.data.push(automaticItems.data[i]);
              }
            }
            else {
              dataToSend.itemListByPackage.automaticItems = automaticItems;
            }
          },

          addItemListByPackageOptionalItems = function(optionalItems){
            if (dataToSend.itemListByPackage.optionalItems.section){
              for (i = 0; i < optionalItems.data.length; i++) {
                dataToSend.itemListByPackage.optionalItems.data.push(optionalItems.data[i]);
              }
            }
            else {
              dataToSend.itemListByPackage.optionalItems = optionalItems;
            }
          },
          addItemListByPackageZones = function(zones){
            if(dataToSend.itemListByPackage.zones.length){
              for (i = 0; i < zones.length; i++) {
                dataToSend.itemListByPackage.zones.push(zones[i]);
              }
            }
            else
              dataToSend.itemListByPackage.zones = zones;
          },

          addItemListByProductInPriceList = function(items){
            var itemInserted = false;
            for (i = 0; i < items.length; i++) {
              for (j = 0; j < dataToSend.itemListByProduct.productInPriceList.items.length; j++)
              {
                itemInserted = false;
                if (dataToSend.itemListByProduct.productInPriceList.items[j].productCode == items[i].productCode){
                  itemInserted = true;
                  dataToSend.itemListByProduct.productInPriceList.items[j].quantity = dataToSend.itemListByProduct.productInPriceList.items[j].quantity + items[i].quantity;
                  dataToSend.itemListByProduct.productInPriceList.items[j].amount = (dataToSend.itemListByProduct.productInPriceList.items[j].quantity * dataToSend.itemListByProduct.productInPriceList.items[j].singlePriceWithoutCurrency).toFixed(2)+ " €";
                  break;
                }
              }
              if (!itemInserted) {
                dataToSend.itemListByProduct.productInPriceList.items.push(items[i]);
              }
            }
          },
          addItemListByProductNotInPriceList = function(items){
            var itemInserted = false;
            for (i = 0; i < items.length; i++) {
              for (j = 0; j < dataToSend.itemListByProduct.productNotInPriceList.items.length; j++)
              {
                itemInserted = false;
                if (dataToSend.itemListByProduct.productNotInPriceList.items[j].productCode == items[i].productCode){
                  itemInserted = true;
                  dataToSend.itemListByProduct.productNotInPriceList.items[j].quantity = dataToSend.itemListByProduct.productNotInPriceList.items[j].quantity + items[i].quantity;
                  dataToSend.itemListByProduct.productNotInPriceList.items[j].amount = (dataToSend.itemListByProduct.productNotInPriceList.items[j].quantity * dataToSend.itemListByProduct.productNotInPriceList.items[j].singlePriceWithoutCurrency).toFixed(2)+ " €";
                  break;
                }
              }
              if (!itemInserted) {
                dataToSend.itemListByProduct.productNotInPriceList.items.push(items[i]);
              }
            }
          };

        this.loaderPopup.show();
        //Initial datas
        dataToSend.token = window.BticinoS4B.token;

        dataToSend.configuration = {
          fileoutformat: "PDF",
          filerepx: "BTReportThermo001"
        };

        //Header
        dataToSend.header = {
          logo: "",
          quote_n: BticinoS4B.Instances.Models.ApplicationModel.get("projectId") ? BticinoS4B.Instances.Models.ApplicationModel.get("projectId") : 0,
          quote_date: BticinoS4B.Instances.Models.ApplicationModel.get("projectModified") ? moment(BticinoS4B.Instances.Models.ApplicationModel.get("projectModified")).format('L') : moment().format('L'),
          quote_pricelist: $.i18n._("IDS_W1_9076"),
          quote_operator: BticinoS4B.Instances.Models.loginModel.get("username"),
          quote_name: BticinoS4B.Instances.Models.ApplicationModel.get("projectName") ? BticinoS4B.Instances.Models.ApplicationModel.get("projectName") : "quote"
        };

        //Footer
        dataToSend.footer = {};

        //String
        dataToSend.string = {
          'IDS_W1_9021': $.i18n._('IDS_W1_9021'),
          'IDS_W1_9022': $.i18n._('IDS_W1_9022'),
          'IDS_W1_9023': $.i18n._('IDS_W1_9023'),
          'IDS_W1_9024': $.i18n._('IDS_W1_9024'),
          'IDS_W1_9037': $.i18n._('IDS_W1_9037'),
          'IDS_W1_9038': $.i18n._('IDS_W1_9038'),
          'IDS_W1_9039': $.i18n._('IDS_W1_9039'),
          'IDS_W1_9040': $.i18n._('IDS_W1_9040'),
          'IDS_W1_9087': $.i18n._('IDS_W1_9087')
        };

        dataToSend.itemListByPackage                = {};
        dataToSend.itemListByPackage.externalItems  = {};
        dataToSend.itemListByPackage.automaticItems = {};
        dataToSend.itemListByPackage.optionalItems  = {};
        dataToSend.itemListByPackage.zones          = {};

        //ItemListByProduct
        dataToSend.itemListByProduct = {
          productInPriceList: {
            section: $.i18n._("IDS_W1_9034"),
            items: []
          },
          productNotInPriceList: {
            section: $.i18n._("IDS_W1_9094"),
            items: []
          }
        };

        if (window.BticinoS4B.solution.audioVideo.inserted) {
          addItemListByPackageExternalItems(BticinoS4B.modelToExport.audioVideo.itemListByPackage.externalItems);
          addItemListByPackageAutomaticItems(BticinoS4B.modelToExport.audioVideo.itemListByPackage.automaticItems);
          addItemListByPackageOptionalItems(BticinoS4B.modelToExport.audioVideo.itemListByPackage.optionalItems);
          addItemListByPackageZones(BticinoS4B.modelToExport.audioVideo.itemListByPackage.zones);
          
          addItemListByProductInPriceList(BticinoS4B.modelToExport.audioVideo.itemListByProduct.productInPriceList.items);
          addItemListByProductNotInPriceList(BticinoS4B.modelToExport.audioVideo.itemListByProduct.productNotInPriceList.items);

          grandTotal = grandTotal + BticinoS4B.modelToExport.audioVideo.grandTotal;
        }

        if (window.BticinoS4B.solution.automation.inserted) {
          addItemListByPackageExternalItems(BticinoS4B.modelToExport.automation.itemListByPackage.externalItems);
          addItemListByPackageAutomaticItems(BticinoS4B.modelToExport.automation.itemListByPackage.automaticItems);
          addItemListByPackageOptionalItems(BticinoS4B.modelToExport.automation.itemListByPackage.optionalItems);
          addItemListByPackageZones(BticinoS4B.modelToExport.automation.itemListByPackage.zones);
          
          addItemListByProductInPriceList(BticinoS4B.modelToExport.automation.itemListByProduct.productInPriceList.items);
          addItemListByProductNotInPriceList(BticinoS4B.modelToExport.automation.itemListByProduct.productNotInPriceList.items);

          grandTotal = grandTotal + BticinoS4B.modelToExport.automation.grandTotal;
        }
        
        if (window.BticinoS4B.solution.intrusionDetection.inserted) {
          addItemListByPackageExternalItems(BticinoS4B.modelToExport.intrusionDetection.itemListByPackage.externalItems);
          addItemListByPackageAutomaticItems(BticinoS4B.modelToExport.intrusionDetection.itemListByPackage.automaticItems);
          addItemListByPackageOptionalItems(BticinoS4B.modelToExport.intrusionDetection.itemListByPackage.optionalItems);
          addItemListByPackageZones(BticinoS4B.modelToExport.intrusionDetection.itemListByPackage.zones);

          addItemListByProductInPriceList(BticinoS4B.modelToExport.intrusionDetection.itemListByProduct.productInPriceList.items);
          addItemListByProductNotInPriceList(BticinoS4B.modelToExport.intrusionDetection.itemListByProduct.productNotInPriceList.items);

          grandTotal = grandTotal + BticinoS4B.modelToExport.intrusionDetection.grandTotal;
        }

        if (window.BticinoS4B.solution.thermoregulation.inserted) {
          addItemListByPackageExternalItems(BticinoS4B.modelToExport.thermoregulation.itemListByPackage.externalItems);
          addItemListByPackageAutomaticItems(BticinoS4B.modelToExport.thermoregulation.itemListByPackage.automaticItems);
          addItemListByPackageOptionalItems(BticinoS4B.modelToExport.thermoregulation.itemListByPackage.optionalItems);
          addItemListByPackageZones(BticinoS4B.modelToExport.thermoregulation.itemListByPackage.zones);

          addItemListByProductInPriceList(BticinoS4B.modelToExport.thermoregulation.itemListByProduct.productInPriceList.items);
          addItemListByProductNotInPriceList(BticinoS4B.modelToExport.thermoregulation.itemListByProduct.productNotInPriceList.items);
          ;
          grandTotal = grandTotal + BticinoS4B.modelToExport.thermoregulation.grandTotal;
        }

        dataToSend.generic = {
          estimateAmount: grandTotal.toFixed(2) + " €"
        };

        $.ajax({
          type: "POST",
          datatype: "json",
          contentType: "application/json",
          url: "/btreport/JSonInterface.asmx/JSonMakeReportThermo",
          data: JSON.stringify(dataToSend),
          success: function(data) {
            var pdfUrl = data.d.fileUrl;
            that.addDownloadView(pdfUrl);
          },
          error: function(e) {
            this.loaderPopup.hide();
          }
        });*/
      },

      exportGlobalConfiguration: function() {
        alert('exportGlobalConfiguration');
      },

      forwardProjectByEmail: function() {
        var CBSendMail = function(emailTo, textBody) {
          var subject, body, defaultBody;
          subject = 'Forwarding S4B project: ' + BticinoS4B.Instances.Models.ApplicationModel.get("projectName");
          defaultBody = 'This is the link of the project: ' + BticinoS4B.baseUrl + '#forward?projectID=' + BticinoS4B.ConversionManager.d2h(BticinoS4B.Instances.Models.ApplicationModel.get("projectId"));
          body = defaultBody + '\n\r' + textBody;
          window.BticinoS4B.Instances.Services.wizardServices.forwardProjectByEmail(emailTo, subject, body);
        };
        this.checkToken();
        if (BticinoS4B.Instances.Models.ApplicationModel.get("projectId")) {
          this.sendMailPopup.show(CBSendMail);
        }
      },

      addDownloadView: function(pdfUrl) {
        var loaderView = this.loaderPopup;
        var title = loaderView.$el.find(".header p");
        var that = this;

        loaderView.$el.find(".content").fadeOut("100", function() {
          var content = loaderView.$el.find(".content");
          content.html("");
          content.append("<a data-bypass target=\"_blank\" href=\"" + pdfUrl + "\" class=\"download-button dataBypass\"><button class=\"orange-button\">Download</button></a>");
          content.fadeIn("100");
          content.find(".download-button").bind("click", function(e) {
            e.preventDefault();
            loaderView.hide();
            window.open(pdfUrl);
          });
        });

        title.fadeOut("100", function() {
          title.text($.i18n._("IDS_W1_9096"));
          title.fadeIn("100", function() {
            $.colorbox.resize();
          });
        });
      },

      isInsertedOneSystem: function() {
        if (window.BticinoS4B.solution.thermoregulation.inserted || window.BticinoS4B.solution.audioVideo.inserted || window.BticinoS4B.solution.automation.inserted || window.BticinoS4B.solution.intrusionDetection.inserted)
          return true;
        else
          return false;
      },

      beforeRender: function() {
        this.loadPopup = new Header.LoadView({
          model: {
            title: 'IDS_W4_9001'
          }
        });
        this.importPopup = new Header.ImportView({
          model: {
            title: 'IDS_W1_9142'
          }
        });
        this.savePopup = new Header.SaveView({
          model: {
            title: 'IDS_W4_9003'
          }
        });
        this.saveSinglePopup = new Header.SaveSingleView({
          model: {
            title: 'IDS_W4_9003'
          }
        });
        this.renamePopup = new Header.RenameView({
          model: {
            title: 'IDS_W4_9008'
          }
        });
        this.infoPopup = new Header.InfoView({
          model: {
            title: 'IDS_W4_9009'
          }
        });
        this.logoutPopup = new Header.LogoutView({
          model: {
            title: 'IDS_W4_9006'
          }
        });
        this.requestDataStoragePopup = new Header.RequestDataStorageView({
          model: {
            title: 'IDS_W4_9002'
          }
        });
        this.requestProjectStoragePopup = new Header.RequestProjectStorageView({
          model: {
            title: 'IDS_W4_9002'
          }
        });
        this.loaderPopup = new Header.LoaderView({
          model: {
            title: 'IDS_W4_9009'
          }
        });
        this.sendMailPopup = new Header.SendMailView({
          model: {
            title: 'IDS_W1_9187'
          }
        });

        var actuatorWizardModel = Backbone.Model.extend({
          defaults: {
            title             : 'Scelta attuatore',
            compatibility     : ['l'],
            filterProperty    : 'on/off',
            filterSlave       : false,
            filterType        : [],
            filterLoad        : [],
            filteredPackages  : [],
            comparedPackagesId: [],
            comparedPackages  : [],
            nrOfPackages      : 0,
            packageToAdd      : undefined
          },

          initialize: function() {
            this.bind("change:Packages", this.fetchProductPackages);
            this.bind("change:filterProperty", this.updateFilteredPackages);
            this.bind("change:filterSlave", this.updateFilteredPackages);
            this.bind("change:filterType", this.updateFilteredPackages);
            this.bind("change:filterLoad", this.updateFilteredPackages);
            //console.log('initialize actuatorWizardModel');
            //this.fetchPackages();
          },

          resetValues: function(){
            /*this.set('filterProperty', 'on/off');
            this.set('filterSlave', false);
            this.set('filterType', []);
            this.set('filterLoad', []);
            this.set('filteredPackages', []);
            this.set('comparedPackagesId',[]);
            this.set('comparedPackages',[]);
            this.set('packageToAdd', undefined);*/
          },

          setCompatibilities: function(value){
            this.set('compatibility', value);
          },

          setPackageToAdd: function(id){
            var that = this,
                tmpPack;
            
            tmpPack = _.filter(that.get('filteredPackages'), function(pack) {
              return ( pack.packageClassId == id);
            });

            this.set('packageToAdd', tmpPack);
          },

          setComparedPackages: function() {
            var that = this,
                tmpPack;
            this.set('comparedPackages', []);

            tmpPack = _.filter(that.get('filteredPackages'), function(pack) {
              return ( that.get('comparedPackagesId').indexOf(pack.packageClassId) >= 0);
            });

            this.set('comparedPackages', tmpPack);
          },

          updateFilteredPackages: function() {
            //console.log('updateFilteredPackages');
            //console.log(this.get('Packages'));
            var compatibility = this.get('compatibility')[0];
            var actuatorIsDim = (this.get('filterProperty') == 'on/off') ? false : true;
            var actuatorSlave = this.get('filterSlave');
            var tmpPackages = this.get('Packages') ? this.get('Packages').slice() : undefined;
            var filterType = this.get('filterType');
            var filterLoad = this.get('filterLoad');

            if (tmpPackages){
              //filter by compatibilities
              tmpPackages = tmpPackages.filter(function(pack) {
                // luci or tapparelle/persiane
                return pack.specialVars.compatibilities.indexOf(compatibility) !== -1;
              })
              //filter Packages by property
              tmpPackages = tmpPackages.filter(function(pack) {
                // on/off or dimmer
                return pack.specialVars.isDim === actuatorIsDim;
              });

              //filter Packages by master/slave
              tmpPackages = tmpPackages.filter(function(pack) {
                // master or slave
                return (!actuatorSlave) ? true : (pack.specialVars.isMaster == false);
              });

              //console.log(tmpPackages);
              //filter Packages by type
              tmpPackages = tmpPackages.filter(function(pack) {
                // green or yellow in typeload
                var able = filterType.length == 0 ? true : false;
                if(!able) {
                  for(var i=0; i <filterType.length; i++)
                  {
                    var filterTypeValue = filterType[i];
                    able = (pack.specialVars[filterTypeValue] &&
                           (pack.specialVars[filterTypeValue].color == 'green' ||
                            pack.specialVars[filterTypeValue].color == 'yellow')) ? true : false;
                    if (able)
                    {
                      break;
                    }
                  }
                }
                return (able);
              });

              //console.log(tmpPackages);
              //filter Packages by load
              tmpPackages = tmpPackages.filter(function(pack) {
                // green or yellow in typeload
                var able = filterLoad.length === 0 ? true : false;
                if(!able) {
                  for(var i=0; i <filterLoad.length; i++)
                  {
                    var filterLoadValue = filterLoad[i];
                    for (var prop in pack.specialVars) {
                      if (prop.indexOf("aw") !== -1) {
                        powerValue = parseInt(pack.specialVars[prop].power);
                             if ((filterLoadValue == 'awLoad1') && (powerValue >= 60) && (powerValue <= 400)) { able = true; }
                        else if ((filterLoadValue == 'awLoad2') && (powerValue >= 2500)) { able = true; }
                        else if ((filterLoadValue == 'awLoad3') && (powerValue >= 1000)) { able = true; }
                        else if ((filterLoadValue == 'awLoad4') && (powerValue >= 60) && (powerValue <= 300)) { able = true; }
                        else if ((filterLoadValue == 'awLoad5') && (powerValue >= 60) && (powerValue <= 600)) { able = true; }
                        else if ((filterLoadValue == 'awLoad6') && (powerValue >= 50) && (powerValue <= 500)) { able = true; }
                      }
                    };
                    if (able)
                    {
                      break;
                    }
                  }
                }
                return (able);
              });

              //console.log(tmpPackages);
              this.set('filteredPackages', tmpPackages);
              this.set('nrOfPackages', this.get('filteredPackages').length);
              //console.log(this.get('nrOfPackages'));
              this.trigger('packages:updated');
            }
          },

          fetchProductPackages: function() {
            //console.log('fetchProductPackages');
            var PackagesLength = this.get('Packages').length,
              cPackageClass,
              cPackageClassId,
              addItemToPackage = function(data) {
                var items = {};
                //console.log('addItemToPackage');
                var mainProduct = _.filter(data.products, function(iterableProduct) {
                    return iterableProduct.mnemonic === 1;
                  })[0],
                  secondaryProducts = _.filter(data.products, function(iterableProduct) {
                    return iterableProduct.mnemonic !== 1;
                  });
                items.mainProduct = mainProduct;
                items.secondaryProducts = secondaryProducts;
                cPackageClass.items = items;
              };

            for (var i = 0; i < PackagesLength; i++) {
              //console.log(this.get('Packages')[i]);
              cPackageClass = this.get('Packages')[i];
              cPackageClassId = cPackageClass.packageClassId;

              BticinoS4B.Instances.Models.ApplicationModel.getProducts(cPackageClassId, addItemToPackage);

            }

            //
            this.set('filteredPackages', this.get('Packages'));
            this.set('nrOfPackages', this.get('filteredPackages').length);
            this.updateFilteredPackages();
          },

          dividePackagesInGroups: function() {
            var Packages = this.get("Packages"),
              PackagesLength = Packages.length;

            var groups = _.groupBy(Packages, function(iterablePackage) {
                return iterablePackage.specialVars.groupId;
              }),
              choosenGroup = this.get("choosenGroup");
            groups = [{
              code: "1",
              name: "IDS_WAM1_821",
              packages: groups["1"]
            }, {
              code: "2",
              name: "IDS_WAM1_822",
              packages: groups["2"]
            }, {
              code: "3",
              name: "IDS_WAM1_823",
              packages: groups["3"]
            }, {
              code: "4",
              name: "IDS_WAM1_824",
              packages: groups["4"]
            }, {
              code: "5",
              name: "IDS_WAM1_825",
              packages: groups["5"]
            }];

            this.set("groups", groups);
          },

          fetchPackages: function() {
            //console.log('fetchPackages actuatorWizardModel');
            this.trigger("packages:fetching");
            if ((!this.get("packagesFetched")) || (this.get("packagesFetched") && BticinoS4B.Instances.Models.QuoteTypesMenuModel.QuoteType() == "webapp")) {
              var that = this,
                groups = this.get("groups"),
                //Defining race conditions variables
                dataFetchCompleted = false,
                i = 0;

              //Race condition check
              var checkRaceCondition = function() {
                if (dataFetchCompleted) {
                  that.dividePackagesInGroups();
                  that.set("packagesFetched", true);
                  that.trigger("packages:fetched");
                }
              };

              //Defining success callbacks
              var dataFetchSuccessCallback = function(data) {
                var Packages = data.packages,
                  PackagesLength = Packages.length;

                for (i = 0; i < PackagesLength; i++) {
                  if (Packages[i].specialVars && Packages[i].specialVars !== "" && typeof(Packages[i].specialVars) !== "object")
                    Packages[i].specialVars = JSON.parse(Packages[i].specialVars);
                }

                that.set('Packages', Packages);
                dataFetchCompleted = true;
                checkRaceCondition();
              };
              
              BticinoS4B.Instances.Models.ApplicationModel.getPackagesByIdWizardChoice("818", dataFetchSuccessCallback, undefined, true);
            }
          }
        });

        this.actuatorWizardPopup = new Header.actuatorWizardView({
          model: new actuatorWizardModel
        });

        this.insertView('.popups', this.loadPopup);
        this.insertView('.popups', this.importPopup);
        this.insertView('.popups', this.savePopup);
        this.insertView('.popups', this.renamePopup);
        this.insertView('.popups', this.infoPopup);
        this.insertView('.popups', this.logoutPopup);
        this.insertView('.popups', this.requestDataStoragePopup);
        this.insertView('.popups', this.requestProjectStoragePopup);
        this.insertView('.popups', this.loaderPopup);
        this.insertView('.popups', this.actuatorWizardPopup);
      },

      afterRender: function() {
        var title = this.$el.find("h1")[0];
        var image = $(title).children("img")[0];

        if (!image.complete)
          $(image).load(function() {
            $(title).css("margin-left", $(title).width() / -2 + "px");
          });
        else
          $(title).css("margin-left", $(title).width() / -2 + "px");
      }
    });

    // Required, return the module for AMD compliance
    return Header;

  });